import React, {
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  AiOutlineClockCircle,
  AiOutlineQuestion,
} from "react-icons/ai";
import { Controller, useForm, useWatch, FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import CircularLoader from "../../../common/CircularLoader/CircularLoader";
import CustomButton from "../../../common/Button/CustomButton";
import {
  baseURLImage,
  getDifferenceArray,
  getNameProfile,
  parseBooleanVal,
  validateCurrentDate,
  validateImage,
} from "../../../../Utils/utils";
import SelectOption from "../../../common/Select/Select";
import {
  // DateValidaionOptions,
  EMAIL_REGEX_EXP,
  planManagedByOptions,
  PRIMARY_DISABILITY_OPTIONS,
  STATES_LIST,
  // SERVICE_CATALOG_STATES,
  CATEGORY_ITEM_NAME_AND_NOTES,
  REGEX_PHONE_NUMBER,
  GenderOptions,
  USER_ROLE,
  PARTICIPANT_TYPES,
} from "../../../../Constants/constant";
import SwitchInput from "../../../common/Input/SwitchInput";
import moment from "moment";
import _, { isArray } from "lodash";
import { roleAccess } from "helpers/RolesPermission";
import {
  BLK_PORTAL_PREMISSION_KEYS_CHILDREN,
  PAYROLL_PLATFORMS,
  PERMISSION_KEYS,
  PERMISSION_KEYS_CHILDREN,

} from "store/constants";
// import { HiOutlineTrash } from "react-icons/hi";
// import InputField from "components/common/Input/Input";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import { LoginContext } from "helpers/LoginContext";
import { useSelector } from "react-redux";
import { getPaymentSettings, getUser } from "store/selector/auth.selector";
import PlanUpgradeGate from "components/common/PlanUpgradeGate/PlanUpgradeGate";
import {
  getFamilyAppLoginUpgradeMessage,
  isFamilyLoginAllowed,
  isFamilyAppLoginAllowed,
  isParticipantLoginAllowed,
  mergePaymentSetting,
  normalizePaymentSetting,
} from "helpers/planFeatures";
import { toast } from "react-toastify";
import DeleteParticipantModal from "pages/ServiceProvider/ParticipantsList/DeleteParticipantModal";
import usePayrollAuthentication from "hooks/usePayrollAuthentication";
import { FiArrowUpRight, FiCheck, FiX } from "react-icons/fi";
import Loader from "components/common/Loader/Loader";
import SwitchWithIcon from "components/common/SwitchWithIcon";
import ImageDisplayModal from "pages/HRM/Pages/TeamManagment/ImageDisplayModalForXeroWorker";
import MultiLevelDropdown from "components/common/MultilevelDropdown";
import api from "store/services/sp.services";
import participantApi from "store/services/participant.services";
import { apiGetRequest, apiPostRequest } from "helpers/Requests";
import AddressAutocomplete from "components/common/GoogleMap/AddressAutoComplete";
import ParticipantShiftTasksNotes, {
  appendParticipantTasksToFormData,
  resolveSettingTasks,
} from "./ParticipantShiftTasksNotes";
import FamilyMemberConfirmModal from "./FamilyMemberConfirmModal";

import {
    URL_ROSTERING_SHIFT_END_QUESTION,
    URL_ROSTERING_SHIFT_END_QUESTION_FOR_WORKER,
    URL_SP_REGISTER_FAMILY_MEMBER,
    URL_SP_VALIDATE_FAMILY_MEMBER,
    URL_SP_UNLINK_FAMILY_MEMBER,
    URL_SP_UPDATE_FAMILY_MEMBER,
    URL_SP_RESEND_FAMILY_APP_INVITE,
    URL_TEAM_LEAD_GET_REGION_LIST,
    URL_SP_PARTICIPANT_COMPLIANCE_PROFILES,
    URL_WORKER_PARTICIPANT_COMPLIANCE_PROFILES,
} from "store/services/URL";
import DateRangeWithRegister from "components/common/DateRangePicker/DateRangePickerWithRegister";
import { serviceTypesRequest } from "../../../../helpers/apiCalls";
import { fromJS } from "immutable";
import {
  fundingTypeFromInvoiceServiceTypeName,
  groupServiceTypesByFundingType,
} from "../../../../Utils/rosteringFundingType";
import useCareLabels from "hooks/useCareLabels";

const MAX_FAMILY_MEMBER_EMAILS = 5;
const FAMILY_INVITE_LINK_TTL_HOURS = 72;

const normalizeFamilyEmailString = (value) => {
  if (value === null || value === undefined) return "";
  const s = String(value).trim();
  if (!s || s.toLowerCase() === "null") return "";
  return s;
};

const pickFamilyUserEmailFromPayload = (payload) => {
  if (!payload || typeof payload !== "object") return "";
  const snake = normalizeFamilyEmailString(payload.family_user?.email);
  if (snake) return snake;
  const camel = normalizeFamilyEmailString(payload.familyUser?.email);
  if (camel) return camel;
  const linkedUser = normalizeFamilyEmailString(payload.user?.email);
  if (linkedUser) return linkedUser;
  return "";
};

const pickFamilyMemberEmailsFromPayload = (payload, options = {}) => {
  return pickFamilyMembersFromPayload(payload, options).map((m) => m.email);
};

const pickFamilyMembersFromPayload = (payload, options = {}) => {
  if (!payload || typeof payload !== "object") return [];
  const allowLegacySingle = options.allowLegacySingle !== false;
  const rawList =
    payload.family_member_emails ??
    payload.familyMemberEmails ??
    payload.family_users ??
    payload.familyUsers;
  if (Array.isArray(rawList) && rawList.length > 0) {
    const members = [];
    const seen = new Set();
    rawList.forEach((item) => {
      let email = "";
      let status = "pending";
      let hasStatusSignal = false;
      let canResendInvite = false;
      if (typeof item === "string") {
        email = normalizeFamilyEmailString(item);
      } else if (item && typeof item === "object") {
        email = normalizeFamilyEmailString(item.email);
        if (
          item.can_resend_invite === true ||
          item.canResendInvite === true
        ) {
          canResendInvite = true;
        }
        const rawStatus = String(item.status || "").toLowerCase();
        const subId = item.sub_id || item.subId || null;
        if (rawStatus === "active" || item.password_set === true || subId) {
          status = "active";
          hasStatusSignal = true;
        } else if (rawStatus === "pending") {
          status = "pending";
          hasStatusSignal = true;
        } else if (Object.prototype.hasOwnProperty.call(item, "sub_id") ||
          Object.prototype.hasOwnProperty.call(item, "subId")) {
          // Explicit empty sub_id => pending
          status = "pending";
          hasStatusSignal = true;
        }
      }
      const key = email.toLowerCase();
      if (!email || seen.has(key)) return;
      seen.add(key);
      members.push({ email, status, hasStatusSignal, canResendInvite });
    });
    return members.slice(0, MAX_FAMILY_MEMBER_EMAILS);
  }
  if (!allowLegacySingle) return [];
  const single = pickFamilyUserEmailFromPayload(payload);
  return single
    ? [{ email: single, status: "pending", hasStatusSignal: false }]
    : [];
};

const createFamilyEmailEntry = (
  email = "",
  baselineEmail = "",
  { inviteStatus = "pending", canResendInvite = false } = {}
) => {
  const normalized = normalizeFamilyEmailString(email);
  const baseline = normalizeFamilyEmailString(baselineEmail) || normalized;
  const resolvedStatus = baseline
    ? inviteStatus === "active"
      ? "active"
      : "pending"
    : "pending";
  return {
    key: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    email: normalized,
    baselineEmail: baseline,
    editMode: !baseline,
    userExist: false,
    inviteStatus: resolvedStatus,
    canResendInvite:
      resolvedStatus === "active" ? false : canResendInvite === true,
  };
};

const unwrapParticipantFromDetailResponse = (response) => {
  const d = response?.data;
  if (!d) return null;
  let p = d.participant ?? d.data?.participant;
  if (!p) return null;
  if (p.data && typeof p.data === "object" && !Array.isArray(p.data)) {
    return { ...p, ...p.data };
  }
  return p;
};

const unwrapParticipantSettingResponse = (response) => {
  if (!response || typeof response !== "object") return response;
  const inner = response.data;
  if (inner && typeof inner === "object" && !Array.isArray(inner)) {
    if (
      inner.data &&
      typeof inner.data === "object" &&
      !Array.isArray(inner.data)
    ) {
      return inner.data;
    }
    return inner;
  }
  return response;
};

const parseFamilyMemberUserExist = (validateRes) =>
  validateRes?.data?.data?.user_exist === true;

const FAMILY_EMAIL_DEBOUNCE_MS = 500;
const FAMILY_EMAIL_FORMAT_MESSAGE =
  "Please enter a valid email address (e.g. name@example.com).";
// Stricter than shared EMAIL_REGEX_EXP: require a real domain with TLD.
const FAMILY_EMAIL_REGEX =
  /^[A-Z0-9](?:[A-Z0-9._%+-]*[A-Z0-9])?@[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?(?:\.[A-Z]{2,24})+$/i;

const getFamilyEmailFormatError = (email) => {
  const trimmed = (email || "").trim();
  if (!trimmed) return "";
  if (trimmed.length > 255) return FAMILY_EMAIL_FORMAT_MESSAGE;
  if (trimmed.includes("..")) return FAMILY_EMAIL_FORMAT_MESSAGE;
  return FAMILY_EMAIL_REGEX.test(trimmed) ? "" : FAMILY_EMAIL_FORMAT_MESSAGE;
};

const buildFamilyEmailRowsFromList = (membersOrEmails) => {
  const members = (membersOrEmails || [])
    .map((item) => {
      if (typeof item === "string") {
        const email = normalizeFamilyEmailString(item);
        return email ? { email, status: "pending" } : null;
      }
      if (item && typeof item === "object") {
        const email = normalizeFamilyEmailString(item.email);
        if (!email) return null;
        return {
          email,
          status: item.status === "active" ? "active" : "pending",
          canResendInvite:
            item.canResendInvite === true || item.can_resend_invite === true,
        };
      }
      return null;
    })
    .filter(Boolean);

  const unique = [];
  const seen = new Set();
  members.forEach((m) => {
    const key = m.email.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    unique.push(m);
  });
  const limited = unique.slice(0, MAX_FAMILY_MEMBER_EMAILS);
  const uniqueEmails = limited.map((m) => m.email);
  const rows = limited.map((m) =>
    createFamilyEmailEntry(m.email, m.email, {
      inviteStatus: m.status,
      canResendInvite: m.canResendInvite,
    })
  );
  if (rows.length < MAX_FAMILY_MEMBER_EMAILS) {
    rows.push(createFamilyEmailEntry());
  }
  return { uniqueEmails, rows };
};

const Settings = (props) => {
  const { participantLabel, participantLabelPlural } = useCareLabels();
  const {
    settingData,
    fetchSettingsData,
    workersList,
    fetchWorkers,
    isLoading,
    settingLoading,
    beginParticipantSettingUpdate,
    syncParticipantSettings,
    failParticipantSettingUpdate,
    supportCoordinatorsList,
    alliedHealthWorkersList,
    getCatalogServicesSubCategory,
    catalogStates,
  } = props;
  const { uuid } = useParams();
  const { isUserGracePeriodOver } = useContext(LoginContext);
  const currentUser = useSelector(getUser);
  const paymentSetting = useSelector(getPaymentSettings);
  const planFeatureUser = useMemo(
    () => ({
      ...currentUser,
      payment_setting: normalizePaymentSetting(
        mergePaymentSetting(currentUser?.payment_setting, paymentSetting)
      ),
    }),
    [currentUser, paymentSetting]
  );
  const familyLoginAllowed = isFamilyLoginAllowed(planFeatureUser);
  const participantLoginAllowed =
    isParticipantLoginAllowed(planFeatureUser);
  const familyAppLoginAllowed = isFamilyAppLoginAllowed(planFeatureUser);
  const { isAuthenticateForPayrolls, isCheckPayrollAuthLoading } =
    usePayrollAuthentication();
  const navigate = useNavigate();
  const shiftTasksNotesRef = useRef(null);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { errors },
    clearErrors,
  } = useForm({
    defaultValues: {
      dob: null,
      planStartDate: null,
      planEndDate: null,
    },
  });
  const watchFormData = watch();

  const [enabled, setEnabled] = useState(false);
  const [optInStatus, setOptInStatus] = useState('opted_in');
  const [complianceProfiles, setComplianceProfiles] = useState([]);
  const [assignedCompliance, setAssignedCompliance] = useState(null);
  const [complianceError, setComplianceError] = useState("");
  const [supportCoordination, setSupportCoordination] = useState(false);
  const [alliedHealth, setAlliedHealth] = useState(false);
  const [workers, setWorkers] = useState([]);
  const [Conditions, setConditions] = useState([]);
  const [supportCoordinators, setSupportCoordinators] = useState([]);
  const [alliedHealthers, setAlliedHealthers] = useState([]);
  const [picture, setPicture] = useState(null);
  const [assignedWorkers, setAssignedWorkers] = useState([]);
  const [assignedConditions, setAssignedConditions] = useState([]);
  const [assignedSupportCoordinators, setAssignedSupportCoordinators] =
    useState([]);
  const [assignedAlliedHealther, setAssignedAlliedHealther] = useState([]);
  const [assignedParticipantConditions, setassignedParticipantConditions] =
    useState([]);
  const [user, setUser] = useState(null);
  const [file, setFile] = useState(undefined);
  const [planBy, setPlanBy] = useState([]);
  const [ParticipantConditions, setParticipantConditions] = useState([]);
  const [primaryDisability, setPrimaryDisability] = useState(null);
  const [gender, setGender] = useState(null);
  const [secondaryDisability, setSecondaryDisability] = useState(null);
  const [catalogState, setCatalogState] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);

  // const [emailFields, setEmailFields] = useState([""]);
  const [emails, setEmails] = useState([]);
  const [focused, setFocused] = useState(false);
  const [rosterInvoicing, setRosterInvoicing] = useState(null);

  const [showXeroImage, setXeroImage] = useState(false);
  const [familyAppEnabled, setFamilyAppEnabled] = useState(false);
  const [participantAppEnabled, setParticipantAppEnabled] = useState(false);
  const [participantEmailStatus, setParticipantEmailStatus] = useState({
    userExist: false,
    validationMessage: "",
    successMessage: "",
    validating: false,
  });
  const [participantAppInviteStatus, setParticipantAppInviteStatus] =
    useState(null);
  const [participantAppCanResendInvite, setParticipantAppCanResendInvite] =
    useState(false);
  const participantEmailValidateSeq = useRef(0);
  const participantEmailValidateSig = useRef("");
  const [familyEmails, setFamilyEmails] = useState([]);
  const [baselineFamilyEmails, setBaselineFamilyEmails] = useState([]);
  const [familyEmailStatus, setFamilyEmailStatus] = useState({});
  const [familyEmailBusyKey, setFamilyEmailBusyKey] = useState(null);
  const [familyMemberConfirm, setFamilyMemberConfirm] = useState(null);
  const familyEmailValidateSeqByKey = useRef({});
  const familyListHydratedForUuid = useRef(null);
  const [allowShiftRequests, setAllowShiftRequests] = useState(false);
  const [ptShiftReqAllow, setPtShiftReqAllow] = useState(false);
  const [regionList, setRegionList] = useState([]);
  const [selectedItems, setSelectedItems] = useState(null);
  const [loader, setLoader] = useState(false);

  const [isFetchServiceCatLoader, setIsFetchServiceCatLoader] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);

  const [labels, setLabels] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [selectedSupportService, setSelectedSupportService] = useState(null);

  const watchAllFields = watch();
  const primaryEmailWatched = useWatch({ control, name: "primary_email" });
  const planStartDate = useWatch({ control, name: "planStartDate" });
  const planEndDate = useWatch({ control, name: "planEndDate" });
  // Use useWatch for state field to ensure it updates when setValue is called
  const stateValue = useWatch({ control, name: "state" });
  // Watch external coordinator fields for character counter
  const externalCoordinatorName = useWatch({ control, name: "externalCoordinatorName" });
  const externalCoordinatorCompany = useWatch({ control, name: "externalCoordinatorCompany" });

  // Memoize the selected state option to ensure SelectOption updates correctly
  const selectedStateOption = useMemo(() => {
    const currentState = stateValue || watchAllFields?.state;
    if (!currentState) return undefined;
    const normalizedState = currentState.toString().toLowerCase().trim();
    const found = STATES_LIST.find(
      (x) =>
        x.value?.toLowerCase() === normalizedState ||
        x.label?.toLowerCase() === normalizedState
    );
    return found || undefined;
  }, [stateValue, watchAllFields?.state]);
  // const handleEmailChange = (index, value) => {
  //   const newEmailFields = [...emailFields];
  //   newEmailFields[index] = value;
  //   setEmailFields(newEmailFields);
  // };

  // const handleAddEmailField = () => {
  //   setEmailFields([...emailFields, ""]);
  // };

  // const handleRemoveEmailField = (index) => {
  //   const newEmailFields = [...emailFields];
  //   newEmailFields.splice(index, 1);
  //   setEmailFields(newEmailFields);
  // };
  const [participantType, setParticipantType] = useState([]);
  const [spDefaultserviceTypes, setSpDefaultServiceTypes] = useState([]);
  useEffect(() => {
    serviceTypesRequest().then((res) => {
      setSpDefaultServiceTypes(res?.data || []);
    });
  }, []);

  const settingsData = useMemo(() => {
    if (settingData) {
      return settingData;
    }
    return null;
  }, [settingData]);

  const showParticipantAppInviteStatus = useMemo(() => {
    const baseline =
      settingsData?.email && settingsData.email !== "null"
        ? String(settingsData.email).trim()
        : "";
    const typed = (primaryEmailWatched || "").trim();
    const hasLinkedUser =
      settingsData?.user_id !== null &&
      settingsData?.user_id !== undefined &&
      settingsData?.user_id !== "" &&
      settingsData?.user_id !== "null";
    const emailMatches =
      baseline &&
      typed &&
      typed.toLowerCase() === baseline.toLowerCase();
    return (
      participantAppEnabled &&
      participantLoginAllowed &&
      hasLinkedUser &&
      Boolean(emailMatches)
    );
  }, [
    settingsData?.email,
    settingsData?.user_id,
    primaryEmailWatched,
    participantAppEnabled,
    participantLoginAllowed,
  ]);

  const resolvedSettingTasks = useMemo(
    () => resolveSettingTasks(settingData),
    [
      settingData?.tasks,
      settingData?.participant_tasks,
      settingData?.participantTasks,
    ]
  );
  useEffect(() => {
    if (settingData) {
      setValue("timeZone", settingsData?.timezone);
    }
    getServiceTypes();
  }, []);

  useEffect(() => {
    if (settingData) {
      // Assuming labels are part of settingData
      setLabels(settingData.labels || []);
      setParticipantConditions(
        settingData.labels?.map((label) => ({
          label: label.label,
          value: label.id,
        })) || []
      );
    }
    fetchLabels();
  }, [settingData]);

  const fetchLabels = async () => {
    try {
      const userRole = roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]);
      const endPoint = userRole ? "/sp/labels" : "/worker/labels";
      const response = await apiGetRequest(endPoint);

      if (response.data && response.data.data) {
        setLabels(response.data.data); // Update state with fetched labels
      }
    } catch (error) {
      console.error("Error fetching labels:", error);
    }
  };

  const getServiceTypes = async () => {
    setIsFetchServiceCatLoader(true);
    try {
      const res = await apiGetRequest("/roster-invoices/service-type");
      if (res.data) {
        const modifiedValues = res.data.data.map((item) => ({
          ...item,
          label: item.name,
          value: item.id,
        }));
        setServiceTypes(modifiedValues);
        setIsFetchServiceCatLoader(false);
      }
    } catch (error) {
      setIsFetchServiceCatLoader(false);
    }
  };

  // Filter service types based on selected Service Support (participantType)
  const filteredServiceTypes = useMemo(() => {
    if (!Array.isArray(serviceTypes) || serviceTypes.length === 0) {
      return serviceTypes;
    }

    let visible = serviceTypes;

    // If service supports are selected, restrict by their funding types.
    // Otherwise show everything.
    if (Array.isArray(participantType) && participantType.length > 0) {
      const allowedFundingTypes = new Set(
        participantType.map((pt) =>
          pt?.funding_type
            ? String(pt.funding_type).toUpperCase()
            : fundingTypeFromInvoiceServiceTypeName(pt?.label)
        )
      );

      visible = serviceTypes.filter((serviceType) => {
        const fundingType = serviceType?.funding_type
          ? String(serviceType.funding_type).toUpperCase()
          : fundingTypeFromInvoiceServiceTypeName(serviceType.label);
        return allowedFundingTypes.has(fundingType);
      });
    }

    // Group by funding type so the dropdown renders clear NDIS / Aged Care /
    // Private / Other section headers as dividers.
    return groupServiceTypesByFundingType(visible);
  }, [serviceTypes, participantType]);

  // Flat list (without group wrappers) for validation lookups.
  const filteredServiceTypesFlat = useMemo(() => {
    if (!Array.isArray(filteredServiceTypes)) return [];
    return filteredServiceTypes.flatMap((group) =>
      Array.isArray(group?.options) ? group.options : [group]
    );
  }, [filteredServiceTypes]);

  // Clear service category if it's not in the filtered list after service support changes
  useEffect(() => {
    if (
      watchFormData?.invoice_category_id &&
      filteredServiceTypesFlat.length > 0
    ) {
      const isCurrentCategoryValid = filteredServiceTypesFlat.some(
        (st) => st.id === watchFormData.invoice_category_id
      );
      if (!isCurrentCategoryValid) {
        setValue("invoice_category_id", null);
      }
    }
  }, [filteredServiceTypesFlat, setValue]);

  const handleChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.size >= 2.1 * 1024 * 1024) {
      // Display error message if file size exceeds 6MB
      toast.error(
        "File too large. The maximum allowed size is 2MB. Try a smaller file."
      );
      event.target.value = null;
    } else {
      // Set the selected file as the image and picture if size is within limits
      setFile(URL.createObjectURL(selectedFile));
      setPicture(selectedFile);
    }
  };

  useEffect(() => {
    if (!catalogStates) {
      getCatalogServicesSubCategory({ isService: false });
    }
    if (workersList.length === 0 || supportCoordinatorsList.length === 0) {
      fetchWorkers();
    }
    if (workersList.length === 0 || alliedHealthWorkersList.length === 0) {
      fetchWorkers();
    }
    if (uuid) {
      fetchSettingsData({ participantUUID: uuid });
    }
  }, []);

  useEffect(() => {
    const loadComplianceProfiles = async () => {
      try {
        const isAdminOrManager = roleAccess([
          USER_ROLE.Sp_Admin,
          USER_ROLE.Sp_manager,
        ]);
        const profilesUrl = isAdminOrManager
          ? URL_SP_PARTICIPANT_COMPLIANCE_PROFILES
          : URL_WORKER_PARTICIPANT_COMPLIANCE_PROFILES;
        const res = await apiGetRequest(profilesUrl);
        const body = res?.data ?? res;
        setComplianceProfiles(
          (body?.profiles || []).map((p) => ({
            value: p.uuid,
            label: p.is_default ? `${p.name} (Default)` : p.name,
            is_default: p.is_default,
          }))
        );
      } catch (_) {
        /* profiles optional on settings load */
      }
    };
    loadComplianceProfiles();
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await apiGetRequest("/sp/labels");
  //       if (response.data && response.data.labels) {
  //       } else {
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const onSubmit = async (data) => {
    if (isUserGracePeriodOver) {
      return;
    }
    if (!assignedCompliance?.value) {
      setComplianceError("This field is required");
      toast.error(`${participantLabel} Compliance is required`);
      return;
    }
    setComplianceError("");

    const taskValidationError = shiftTasksNotesRef.current?.validateTasks?.();
    if (taskValidationError) {
      toast.error(taskValidationError);
      return;
    }

    if (participantAppEnabled && participantLoginAllowed) {
      const primaryEmail = (data.primary_email || "").trim();
      if (!primaryEmail) {
        toast.error(
          "Primary email is required when Participant App Access is enabled."
        );
        return;
      }
      const formatError = getFamilyEmailFormatError(primaryEmail);
      if (formatError) {
        toast.error(formatError);
        return;
      }
      if (participantEmailStatus.validating) {
        toast.error("Please wait while the email is being verified.");
        return;
      }
      if (participantEmailStatus.validationMessage) {
        toast.error(participantEmailStatus.validationMessage);
        return;
      }
    }

    const scoordinators = !supportCoordination
      ? []
      : [...assignedSupportCoordinators];

    const ahealther = !alliedHealth ? [] : [...assignedAlliedHealther];
    const assign_workers = [...assignedWorkers, ...scoordinators, ...ahealther];

    let formData = new FormData();
    if (file) {
      const profileImage = picture ? picture : "";
      const validFormats = ["image/jpeg", "image/jpg", "image/png"];
      if (!validFormats.includes(profileImage.type)) {
        return toast.error(
          "Invalid file format. Please upload a JPEG, JPG and PNG image to continue."
        );
      }

      if (profileImage.size >= 2.1 * 1024 * 1024) {
        toast.error(
          "File too large. The maximum allowed size is 2MB. Try a smaller file."
        );
        return;
      }
      try {
        await validateImage(profileImage);
        formData.append("profile_picture", profileImage);
      } catch (error) {
        toast.error(error);
        return;
      }
    }

    formData.append("street_no", data.address ? data.address : "");
    formData.append("state", data.state ? data.state : "");
    formData.append("suburb", data.suburb ? data.suburb : "");
    formData.append("post_code", data.postcode ? data.postcode : "");
    formData.append("lat", data.lat ? data.lat : "");
    formData.append("lng", data.lng ? data.lng : "");
    formData.append("primary_no", data.phone ? data.phone : "");
    formData.append(
      "emergency_contact",
      data.emergencyContactPhone ? data.emergencyContactPhone : ""
    );
    formData.append(
      "emergency_contact_name",
      data.emergencyContactName ? data.emergencyContactName : ""
    );
    formData.append(
      "quick_support",
      data.quickSnapshot ? data.quickSnapshot : ""
    );
    formData.append("timezone", data.timeZone ? data.timeZone : "");
    formData.append("first_name", data.firstName);
    formData.append("last_name", data.lastName);
    formData.append("ndis_no", data.ndisNumber ? data.ndisNumber : "");
    const xeroInvoiceReference = data.invoiceReferenceNumberXero
      ? String(data.invoiceReferenceNumberXero).trim()
      : "";
    const ndisNumberForReference = data.ndisNumber
      ? String(data.ndisNumber).trim()
      : "";
    formData.append(
      "xero_invoice_reference",
      xeroInvoiceReference &&
        xeroInvoiceReference !== ndisNumberForReference
        ? xeroInvoiceReference
        : ""
    );
    formData.append("dob", data.dob ? data.dob : "");
    formData.append(
      "primary_disability",
      data.primary_disability ? data.primary_disability : ""
    );
    formData.append(
      "secondary_disability",
      data.secondary_disability ? data.secondary_disability : ""
    );
    formData.append("email", data.primary_email ? data.primary_email : "");
    formData.append(
      "participantAppEnabled",
      participantAppEnabled && participantLoginAllowed ? "1" : "0"
    );
    formData.append(
      "pt_shift_req_allow",
      participantAppEnabled &&
        participantLoginAllowed &&
        ptShiftReqAllow
        ? "1"
        : "0"
    );
    formData.append("gender", data.gender ? data.gender : "");
    // formData.append("email_for_invoice", data.email ? data.email : "");
    formData.append(
      "plan_start_date",
      data.planStartDate ? data.planStartDate : ""
    );
    formData.append("plan_end_date", data.planEndDate ? data.planEndDate : "");
    formData.append("plan_managed_by", JSON.stringify([planBy]));
    formData.append("status", enabled === true ? "active" : "inactive");
    formData.append("opt_in_status", optInStatus);
    formData.append(
      "participant_compliance_profile_uuid",
      assignedCompliance?.value || ""
    );
    formData.append("support_coordination", supportCoordination);
    formData.append("allied_health", alliedHealth);
    formData.append(
      "status_description",
      data.status_description ? data.status_description : ""
    );
    formData.append(
      "public_guardian",
      data.public_guardian ? data.public_guardian : ""
    );
    formData.append(
      "child_safety_officer",
      data.child_safety_officer ? data.child_safety_officer : ""
    );
    formData.append("plan_nominee", data.plan_nominee ? data.plan_nominee : "");
    formData.append(
      "important_alert",
      data.important_alert ? data.important_alert : ""
    );
    formData.append("shift_instruction", data.shift_instruction || "");
    formData.append("state_id", data.state_id);
    formData.append("invoice_emails", emails ? emails : []);
    formData.append(
      "roster_invoicing_item",
      data.roster_invoicing_item ? data.roster_invoicing_item : ""
    );

    formData.append(
      "plan_manager_name",
      data.planManagerName ? data.planManagerName : ""
    );
    formData.append(
      "plan_manager_email",
      data.planManagerEmail ? data.planManagerEmail : ""
    );
    ParticipantConditions.forEach((item) => {
      formData.append("labels[]", item.value); // Append each label ID
    });

    formData.append(
      "plan_manager_company",
      data.planManagerCompany ? data.planManagerCompany : ""
    );
    formData.append(
      "external_coordinator_name",
      data.externalCoordinatorName ? data.externalCoordinatorName : ""
    );
    formData.append(
      "external_coordinator_email",
      data.externalCoordinatorEmail ? data.externalCoordinatorEmail : ""
    );
    formData.append(
      "external_coordinator_company",
      data.externalCoordinatorCompany ? data.externalCoordinatorCompany : ""
    );
    formData.append(
      "external_coordinator_phone",
      data.externalCoordinatorPhone ? data.externalCoordinatorPhone : ""
    );
    participantType.forEach((option) => {
      formData.append("participant_type[]", parseInt(option.value, 10));
    });

    if (assign_workers && assign_workers.length > 0) {
      for (let i = 0; i < assign_workers.length; i++) {
        formData.append("assign_workers[]", assign_workers[i].value);
      }
    }

    if (data?.xero_contact_id) {
      formData.append("xero_contact_id", data?.xero_contact_id);
    }

    if (data?.invoice_category_id) {
      formData.append("invoice_category_id", data?.invoice_category_id);
    }

    if (selectedItems) {
      const selectedRegion = [selectedItems];
      if (selectedRegion?.length > 0) {
        for (let i = 0; i < selectedRegion?.length; i++) {
          formData.append("region_id[]", selectedRegion[i]?.id);
        }
      }
    }

    if (selectedQuestions && selectedQuestions?.length > 0) {
      selectedQuestions.forEach((question, index) => {
        formData.append(
          `shift_end_questions[${index}][question_id]`,
          question?.id
        );
        formData.append(
          `shift_end_questions[${index}][is_mandatory]`,
          parseBooleanVal(question?.is_mandatory) ? "1" : "0"
        );
      });
    }

    formData.append(
      "familyAppEnabled",
      familyAppEnabled && familyLoginAllowed ? "1" : "0"
    );
    formData.append(
      "familyMemberEmail",
      familyEmails.map((row) => (row.email || "").trim()).filter(Boolean)[0] ??
        ""
    );
    formData.append(
      "allowShiftRequests",
      familyAppEnabled && familyLoginAllowed && allowShiftRequests
        ? "1"
        : "0"
    );
    formData.append(
      "shift_req_allow",
      familyAppEnabled && familyLoginAllowed && allowShiftRequests
        ? "1"
        : "0"
    );

    const changedTasksPayload =
      shiftTasksNotesRef.current?.getChangedTasksPayload?.();
    if (changedTasksPayload !== null && changedTasksPayload !== undefined) {
      appendParticipantTasksToFormData(formData, changedTasksPayload);
    }

    const draftTyped = familyEmails.some(
      (row) => !row.baselineEmail && Boolean((row.email || "").trim())
    );
    if (draftTyped) {
      toast.error(
        "Add the email with ✓, or clear it with ✕, before saving."
      );
      return;
    }

    if (familyAppEnabled && familyLoginAllowed) {
      const committedEmails = familyEmails
        .filter((row) => Boolean(row.baselineEmail))
        .map((row) => (row.email || "").trim())
        .filter(Boolean);

      if (committedEmails.length === 0) {
        toast.error("At least one family member email is required.");
        return;
      }
      if (committedEmails.length > MAX_FAMILY_MEMBER_EMAILS) {
        toast.error(
          `You can add up to ${MAX_FAMILY_MEMBER_EMAILS} family member emails.`
        );
        return;
      }

      const lowerEmails = committedEmails.map((email) => email.toLowerCase());
      if (new Set(lowerEmails).size !== lowerEmails.length) {
        toast.error("Family member emails must be unique.");
        return;
      }

      for (const email of committedEmails) {
        const formatError = getFamilyEmailFormatError(email);
        if (formatError) {
          toast.error(formatError);
          return;
        }
      }

      const anyValidating = familyEmails.some(
        (row) => familyEmailStatus[row.key]?.validating
      );
      if (anyValidating) {
        toast.error("Please wait while the email is being verified.");
        return;
      }

      const validationError = familyEmails
        .map((row) => familyEmailStatus[row.key]?.validationMessage)
        .find(Boolean);
      if (validationError) {
        toast.error(validationError);
        return;
      }
    }

    const committedFamilyEmails = familyEmails
      .filter((row) => Boolean(row.baselineEmail))
      .map((row) => (row.email || "").trim())
      .filter(Boolean);

    const normalizeEmailListKey = (emails) =>
      [...emails]
        .map((email) => String(email || "").trim().toLowerCase())
        .filter(Boolean)
        .sort()
        .join("|");

    const familyEmailsChanged =
      normalizeEmailListKey(committedFamilyEmails) !==
      normalizeEmailListKey(baselineFamilyEmails || []);

    const baselineEmailSet = new Set(
      (baselineFamilyEmails || []).map((email) =>
        String(email || "").trim().toLowerCase()
      )
    );
    const committedEmailSet = new Set(
      committedFamilyEmails.map((email) =>
        String(email || "").trim().toLowerCase()
      )
    );
    const addedFamilyEmails = committedFamilyEmails.filter((email) =>
      !baselineEmailSet.has(String(email || "").trim().toLowerCase())
    );
    const removedFamilyEmails = (baselineFamilyEmails || []).filter(
      (email) =>
        !committedEmailSet.has(String(email || "").trim().toLowerCase())
    );

    beginParticipantSettingUpdate();
    try {
      let familySyncedFromRegister = false;
      if (familyEmailsChanged) {
        // Add-only: attach new emails individually (avoids re-inviting existing pending)
        const isAddOnly =
          removedFamilyEmails.length === 0 && addedFamilyEmails.length > 0;
        let syncRes = null;

        if (isAddOnly) {
          for (const email of addedFamilyEmails) {
            syncRes = await apiPostRequest(URL_SP_REGISTER_FAMILY_MEMBER, {
              pt_uuid: uuid,
              email,
            });
          }
        } else {
          syncRes = await apiPostRequest(URL_SP_REGISTER_FAMILY_MEMBER, {
            pt_uuid: uuid,
            emails: committedFamilyEmails,
          });
        }

        const syncedEmails =
          syncRes?.data?.data?.family_member_emails ??
          syncRes?.data?.family_member_emails ??
          null;
        if (Array.isArray(syncedEmails) && syncedEmails.length > 0) {
          applyFamilyLinkedEmails(syncedEmails);
          familySyncedFromRegister = true;
        }
      }

      // Participant App invite is handled here via participantAppEnabled + email
      // (ParticipantService → linkParticipantAppUser → dispatchAppInviteIfNeeded)
      const settingsResponse = await participantApi.participantSettingUpdate({
        participantUUID: uuid,
        formData,
      });

      if (settingsResponse) {
        const savedParticipant =
          unwrapParticipantSettingResponse(settingsResponse);
        syncParticipantSettings(savedParticipant);
        const familyLinked =
          pickFamilyMembersFromPayload(savedParticipant, {
            allowLegacySingle: false,
          }).length > 0;
        setAllowShiftRequests(
          parseBooleanVal(savedParticipant?.family_app_enabled) &&
            familyLinked &&
            parseBooleanVal(savedParticipant?.shift_req_allow)
        );
        if (savedParticipant?.family_app_enabled !== undefined) {
          setFamilyAppEnabled(
            parseBooleanVal(savedParticipant.family_app_enabled)
          );
        }
        setParticipantAppEnabled(
          parseBooleanVal(savedParticipant?.participant_app_enabled)
        );
        if (savedParticipant?.pt_shift_req_allow !== undefined) {
          setPtShiftReqAllow(
            participantLoginAllowed &&
              parseBooleanVal(savedParticipant.participant_app_enabled) &&
              parseBooleanVal(savedParticipant.pt_shift_req_allow)
          );
        }
        if (
          savedParticipant?.participant_app_login_status === "active" ||
          savedParticipant?.participant_app_login_status === "pending"
        ) {
          setParticipantAppInviteStatus(
            savedParticipant.participant_app_login_status
          );
        }
        setParticipantAppCanResendInvite(
          savedParticipant?.participant_app_can_resend_invite === true
        );
        toast.success("Participant setting updated successfully");
        if (!familySyncedFromRegister) {
          const linkedFromSave = pickFamilyMembersFromPayload(
            savedParticipant,
            { allowLegacySingle: false }
          );
          if (linkedFromSave.length > 0) {
            applyFamilyLinkedEmails(linkedFromSave);
          } else if (
            parseBooleanVal(savedParticipant?.family_app_enabled) &&
            committedFamilyEmails.length > 0
          ) {
            applyFamilyLinkedEmails(committedFamilyEmails);
          }
        }
      }

      await fetchLabels();
    } catch (error) {
      failParticipantSettingUpdate(error);
      console.error("Error updating settings:", error);
      toast.error(
        error?.message || "Failed to save family app access. Please try again."
      );
    }
  };

  // Function to handle changes in Support Service (participantType)

  useEffect(() => {
    if (planBy !== null) {
      setValue("plan", planBy);
    }
  }, [planBy]);

  useEffect(() => {
    if (
      primaryDisability &&
      primaryDisability !== null &&
      primaryDisability.value === "other"
    ) {
      setValue("primary_disability", null);
    }
    if (
      primaryDisability &&
      primaryDisability !== null &&
      primaryDisability.value !== "other"
    ) {
      setValue("primary_disability", primaryDisability.value);
    }
  }, [primaryDisability]);

  useEffect(() => {
    if (
      secondaryDisability &&
      secondaryDisability !== null &&
      secondaryDisability.value === "other"
    ) {
      setValue("secondary_disability", null);
    }
    if (
      secondaryDisability &&
      secondaryDisability !== null &&
      secondaryDisability.value !== "other"
    ) {
      setValue("secondary_disability", secondaryDisability.value);
    }
  }, [secondaryDisability]);

  useEffect(() => {
    if (catalogState && catalogState !== null && catalogState.value) {
      setValue("state_id", catalogState.value);
      clearErrors("state_id");
    }
  }, [catalogState]);

  useEffect(() => {
    if (rosterInvoicing && rosterInvoicing !== null && rosterInvoicing.value) {
      setValue("roster_invoicing_item", rosterInvoicing.value);
      clearErrors("roster_invoicing_item");
    }
  }, [rosterInvoicing]);

  useEffect(() => {
    const emailArray = [];
    settingData?.invoice_emails?.map((item) => emailArray.push(item?.email));
    setEmails(emailArray);
  }, []);

  useEffect(() => {
    // Keep in-progress edits visible while save APIs run (avoid reset from stale store email).
    if (isLoading) {
      return;
    }
    // simulate async api call with set timeout
    if (settingsData && settingsData !== undefined) {
      let primaryDisabilityValue = null;
      let secondaryDisabilityValue = null;
      let rosterInvoicingItem = null;
      const state_id_int =
        typeof settingData.state_id === "string"
          ? parseInt(settingData.state_id, 10)
          : settingData.state_id;
      if (settingData.primary_disability) {
        primaryDisabilityValue = PRIMARY_DISABILITY_OPTIONS.find(
          (x) =>
            x.value.toLowerCase() ===
            settingData.primary_disability.toLowerCase()
        );
        if (
          (primaryDisabilityValue === null ||
            primaryDisabilityValue === undefined) &&
          settingData.primary_disability &&
          settingData.primary_disability.length > 0
        ) {
          setPrimaryDisability({ label: "Other", value: "other" });
        } else {
          setPrimaryDisability(primaryDisabilityValue);
        }
      }
      if (settingData.roster_invoicing_item) {
        rosterInvoicingItem = CATEGORY_ITEM_NAME_AND_NOTES.find(
          (x) =>
            x.value.toLowerCase() ===
            settingData.roster_invoicing_item.toLowerCase()
        );
        if (
          (rosterInvoicingItem === null || rosterInvoicingItem === undefined) &&
          settingData.roster_invoicing_item
        ) {
          setRosterInvoicing(null);
        } else {
          setRosterInvoicing(rosterInvoicingItem);
        }
      }
      if (settingData.secondary_disability) {
        secondaryDisabilityValue = PRIMARY_DISABILITY_OPTIONS.find(
          (x) =>
            x.value.toLowerCase() ===
            settingData.secondary_disability.toLowerCase()
        );
        if (
          (secondaryDisabilityValue === null ||
            secondaryDisabilityValue === undefined) &&
          settingData.secondary_disability &&
          settingData.secondary_disability.length > 0
        ) {
          setSecondaryDisability({ label: "Other", value: "other" });
        } else {
          setSecondaryDisability(secondaryDisabilityValue);
        }
      }
      if (settingData.state_id && catalogStates) {
        const stateObj = catalogStates.find((x) => x.value === state_id_int);
        setCatalogState({ ...stateObj });
      }
      if (spDefaultserviceTypes) {
        setParticipantType(
          settingData.participant_type.map((item) => ({
            value: item.id,
            label: item.name,
            funding_type: item.funding_type,
          }))
        );
      }
      const parsePlanBy =
        typeof settingsData.plan_managed_by === "string" &&
        settingsData.plan_managed_by.includes("label")
          ? JSON.parse(settingsData.plan_managed_by)
          : null;
      setPlanBy(
        parsePlanBy && isArray(parsePlanBy) && parsePlanBy.length > 0
          ? parsePlanBy[0]
          : parsePlanBy
      );
      const participantType = settingsData.participant_type.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setUser({
        primary_email: settingsData.email !== "null" ? settingsData.email : "",
        firstName: settingsData.first_name,
        lastName: settingsData.last_name,
        quickSnapshot: settingsData.quick_support,
        address: settingsData.street_no,
        state: settingsData.state,
        labels: settingsData.labels,
        suburb: settingsData.suburb,
        postcode: settingsData.post_code,
        lat: settingsData.lat || null,
        lng: settingsData.lng || null,
        phone: settingsData.primary_no,
        emergencyContactName: settingsData.emergency_contact_name,
        emergencyContactPhone: settingsData.emergency_contact,
        ndisNumber: settingsData.ndis_no,
        invoiceReferenceNumberXero: (() => {
          const storedRef = settingsData.xero_invoice_reference;
          const hasStoredRef =
            storedRef !== null &&
            storedRef !== undefined &&
            String(storedRef).trim() !== "";
          return hasStoredRef ? String(storedRef).trim() : settingsData.ndis_no || "";
        })(),
        dob: settingsData.dob,
        gender: settingsData.gender,
        public_guardian: settingsData.public_guardian,
        child_safety_officer: settingsData.child_safety_officer,
        plan_nominee: settingsData.plan_nominee,
        // email:
        //   settingData.email_for_invoice !== "null"
        //     ? settingData.email_for_invoice
        //     : "",
        planStartDate: settingsData.plan_start_date,
        planEndDate: settingsData.plan_end_date,
        roster_invoicing_item:
          rosterInvoicingItem === null || rosterInvoicingItem === undefined
            ? settingsData.roster_invoicing_item
            : rosterInvoicingItem
            ? rosterInvoicingItem.value
            : null,
        plan: parsePlanBy,
        primary_disability:
          primaryDisabilityValue === null ||
          primaryDisabilityValue === undefined
            ? settingsData.primary_disability
            : primaryDisabilityValue
            ? primaryDisabilityValue.value
            : null,
        secondary_disability:
          secondaryDisabilityValue === null ||
          secondaryDisabilityValue === undefined
            ? settingsData.secondary_disability
            : secondaryDisabilityValue
            ? secondaryDisabilityValue.value
            : null,
        state_id: state_id_int ?? null,
        status_description: settingData.status_description || "",
        important_alert: settingsData.important_alert || "",
        shift_instruction: settingsData.shift_instruction || "",
        xero_contact_id: settingData?.xero_contact_id,
        invoice_category_id: settingData?.invoice_category_id || "",

        planManagerName: settingsData.plan_manager_name || "",
        planManagerEmail: settingsData.plan_manager_email || "",
        planManagerCompany: settingsData.plan_manager_company || "",

        externalCoordinatorName: settingsData.external_coordinator_name || "",
        externalCoordinatorEmail: settingsData.external_coordinator_email || "",
        externalCoordinatorCompany:
          settingsData.external_coordinator_company || "",
        externalCoordinatorPhone: settingsData.external_coordinator_phone || "",
      });

      setAssignedWorkers(
        settingsData.hasOwnProperty("sp_workers")
          ? settingData.sp_workers.map((x) => {
              const obj = {
                value: x.id,
                label: `${x.first_name} ${x.last_name}`,
              };
              return obj;
            })
          : []
      );
      setAssignedSupportCoordinators(
        settingsData.hasOwnProperty("sp_support_coordinators")
          ? settingData.sp_support_coordinators.map((x) => {
              const obj = {
                value: x.id,
                label: `${x.first_name} ${x.last_name}`,
              };
              return obj;
            })
          : []
      );
      setAssignedAlliedHealther(
        settingsData.hasOwnProperty("sp_allied_healthers")
          ? settingData.sp_allied_healthers.map((x) => {
              const obj = {
                value: x.id,
                label: `${x.first_name} ${x.last_name}`,
              };
              return obj;
            })
          : []
      );
      setEnabled(settingsData.status === "active" ? true : false);
      setOptInStatus(settingsData.opt_in_status || 'opted_in');
      const profile =
        settingData.participant_compliance_profile ||
        settingData.participantComplianceProfile ||
        (settingData.participant_compliance_profile_uuid
          ? {
              uuid: settingData.participant_compliance_profile_uuid,
              name: settingData.participant_compliance_profile_name,
            }
          : null);
      if (profile?.uuid) {
        setAssignedCompliance({
          value: profile.uuid,
          label: profile.name
            ? profile.is_default
              ? `${profile.name} (Default)`
              : profile.name
            : "Compliance",
        });
      } else {
        const defaultProfile =
          complianceProfiles.find((p) => p.is_default) || complianceProfiles[0];
        setAssignedCompliance(defaultProfile || null);
      }
      setSupportCoordination(
        parseBooleanVal(settingsData.support_coordination)
      );
      setAlliedHealth(parseBooleanVal(settingsData.allied_health));
    }
  }, [catalogStates, workersList, complianceProfiles, settingsData, isLoading]);

  useEffect(() => {
    if (settingData?.family_app_enabled === undefined) return;
    setFamilyAppEnabled(parseBooleanVal(settingData.family_app_enabled));
  }, [settingData?.family_app_enabled]);

  useEffect(() => {
    if (settingData?.shift_req_allow === undefined) return;
    const familyLinked =
      pickFamilyMembersFromPayload(settingData, {
        allowLegacySingle: false,
      }).length > 0;
    setAllowShiftRequests(
      parseBooleanVal(settingData.family_app_enabled) &&
        familyLinked &&
        parseBooleanVal(settingData.shift_req_allow)
    );
  }, [
    settingData?.shift_req_allow,
    settingData?.family_app_enabled,
    settingData?.family_member_emails,
  ]);

  useEffect(() => {
    if (settingData?.participant_app_enabled === undefined) {
      return;
    }
    setParticipantAppEnabled(
      parseBooleanVal(settingData.participant_app_enabled)
    );
  }, [settingData?.participant_app_enabled]);

  useEffect(() => {
    const status = settingData?.participant_app_login_status;
    if (status === "active" || status === "pending") {
      setParticipantAppInviteStatus(status);
    } else {
      const hasLinkedUser =
        settingData?.user_id !== null &&
        settingData?.user_id !== undefined &&
        settingData?.user_id !== "" &&
        settingData?.user_id !== "null";
      if (
        !hasLinkedUser ||
        !parseBooleanVal(settingData?.participant_app_enabled)
      ) {
        setParticipantAppInviteStatus(null);
      }
    }
    setParticipantAppCanResendInvite(
      settingData?.participant_app_can_resend_invite === true
    );
  }, [
    settingData?.participant_app_login_status,
    settingData?.participant_app_can_resend_invite,
    settingData?.user_id,
    settingData?.participant_app_enabled,
  ]);

  useEffect(() => {
    if (settingData?.pt_shift_req_allow === undefined) return;
    setPtShiftReqAllow(
      participantLoginAllowed &&
        parseBooleanVal(settingData.participant_app_enabled) &&
        parseBooleanVal(settingData.pt_shift_req_allow)
    );
  }, [
    settingData?.pt_shift_req_allow,
    settingData?.participant_app_enabled,
    participantLoginAllowed,
  ]);

  useEffect(() => {
    if (!participantAppEnabled) {
      participantEmailValidateSig.current = "";
      participantEmailValidateSeq.current += 1;
      setParticipantEmailStatus({
        userExist: false,
        validationMessage: "",
        successMessage: "",
        validating: false,
      });
      return;
    }

    if (!participantLoginAllowed) {
      return;
    }

    const typed = (primaryEmailWatched || "").trim();
    const baseline =
      settingsData?.email && settingsData.email !== "null"
        ? String(settingsData.email).trim()
        : "";
    const sig = `${typed.toLowerCase()}|${baseline.toLowerCase()}`;

    if (participantEmailValidateSig.current === sig) {
      return;
    }
    participantEmailValidateSig.current = sig;

    if (!typed) {
      participantEmailValidateSeq.current += 1;
      setParticipantEmailStatus({
        userExist: false,
        validationMessage: "",
        successMessage: "",
        validating: false,
      });
      return;
    }

    const formatError = getFamilyEmailFormatError(typed);
    if (formatError) {
      participantEmailValidateSeq.current += 1;
      setParticipantEmailStatus({
        userExist: false,
        validationMessage: formatError,
        successMessage: "",
        validating: false,
      });
      return;
    }

    if (baseline && typed.toLowerCase() === baseline.toLowerCase()) {
      participantEmailValidateSeq.current += 1;
      setParticipantEmailStatus({
        userExist: false,
        validationMessage: "",
        successMessage: "",
        validating: false,
      });
      return;
    }

    const participantUserId = settingsData?.user_id;
    const hasParticipantUser =
      participantUserId !== null &&
      participantUserId !== undefined &&
      participantUserId !== "" &&
      participantUserId !== "null";
    if (hasParticipantUser) {
      participantEmailValidateSeq.current += 1;
      setParticipantEmailStatus({
        userExist: false,
        validationMessage: "",
        successMessage: "",
        validating: false,
      });
      return;
    }

    setParticipantEmailStatus({
      userExist: false,
      validationMessage: "",
      successMessage: "",
      validating: true,
    });

    const seq = participantEmailValidateSeq.current + 1;
    participantEmailValidateSeq.current = seq;

    const timer = setTimeout(async () => {
      try {
        const validateRes = await apiPostRequest(
          URL_SP_VALIDATE_FAMILY_MEMBER,
          { email: typed }
        );
        if (seq !== participantEmailValidateSeq.current) return;
        const exists = parseFamilyMemberUserExist(validateRes);
        setParticipantEmailStatus({
          userExist: exists,
          validationMessage: "",
          successMessage: exists
            ? "An account with this email already exists. It will be linked on save."
            : "This email is available. An invite will be sent so they can set their own password.",
          validating: false,
        });
      } catch (e) {
        if (seq !== participantEmailValidateSeq.current) return;
        setParticipantEmailStatus({
          userExist: false,
          validationMessage:
            e?.message || "Could not verify this email. Please try again.",
          successMessage: "",
          validating: false,
        });
      }
    }, FAMILY_EMAIL_DEBOUNCE_MS);

    return () => {
      clearTimeout(timer);
    };
  }, [
    participantAppEnabled,
    participantLoginAllowed,
    primaryEmailWatched,
    settingsData?.email,
    settingsData?.user_id,
  ]);

  useEffect(() => {
    familyListHydratedForUuid.current = null;
  }, [uuid]);

  useEffect(() => {
    if (!settingData || typeof settingData !== "object" || !uuid) return;
    // Hydrate once per participant — re-running on every settings save was
    // clearing the email list mid-request (flicker).
    if (familyListHydratedForUuid.current === uuid) return;

    let cancelled = false;

    const finishHydration = (members, familyAppEnabledFlag) => {
      if (cancelled) return;
      familyListHydratedForUuid.current = uuid;

      // Use DB flag only — do not AND familyLoginAllowed here.
      // Plan gate can be false while payment_setting is still loading; that
      // permanently stuck the toggle off because hydration runs once per uuid.
      const enabled = parseBooleanVal(familyAppEnabledFlag);
      setFamilyAppEnabled(enabled);

      const { uniqueEmails, rows } = buildFamilyEmailRowsFromList(members);
      if (rows.length > 0) {
        setBaselineFamilyEmails(uniqueEmails);
        setFamilyEmails(rows);
      } else if (enabled) {
        setBaselineFamilyEmails([]);
        setFamilyEmails([createFamilyEmailEntry()]);
      } else {
        setBaselineFamilyEmails([]);
        setFamilyEmails([]);
      }
      setFamilyEmailStatus({});
    };

    const linkedFromSettings = pickFamilyMembersFromPayload(settingData);
    const settingsHaveStatus = linkedFromSettings.some((m) => m.hasStatusSignal);

    // String-only lists have no password status — always load participant for Active/Pending.
    if (linkedFromSettings.length > 0 && settingsHaveStatus) {
      finishHydration(linkedFromSettings, settingData.family_app_enabled);
      return;
    }

    (async () => {
      try {
        const endpoint = roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])
          ? `sp/participants/${uuid}`
          : `hrm/participants/${uuid}`;
        const res = await apiGetRequest(endpoint);
        if (cancelled) return;
        const participant = unwrapParticipantFromDetailResponse(res);
        const appLoginStatus = participant?.participant_app_login_status;
        if (appLoginStatus === "active" || appLoginStatus === "pending") {
          setParticipantAppInviteStatus(appLoginStatus);
        }
        setParticipantAppCanResendInvite(
          participant?.participant_app_can_resend_invite === true
        );
        const linked = pickFamilyMembersFromPayload(participant);
        const familyEnabledFlag =
          participant?.family_app_enabled ?? settingData.family_app_enabled;
        if (linked.length > 0) {
          finishHydration(linked, familyEnabledFlag);
        } else if (linkedFromSettings.length > 0) {
          finishHydration(linkedFromSettings, settingData.family_app_enabled);
        } else {
          finishHydration([], familyEnabledFlag);
        }
      } catch (e) {
        if (!cancelled) {
          if (linkedFromSettings.length > 0) {
            finishHydration(
              linkedFromSettings,
              settingData.family_app_enabled
            );
          } else {
            finishHydration([], settingData.family_app_enabled);
          }
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [uuid, settingData]);

  const familyEmailsValidationKey = useMemo(
    () =>
      familyEmails
        .map(
          (row) =>
            `${row.key}|${(row.email || "").trim()}|${row.editMode ? 1 : 0}|${
              row.baselineEmail || ""
            }`
        )
        .join(";"),
    [familyEmails]
  );

  const familyEmailRowValidateSig = useRef({});

  useEffect(() => {
    if (!familyAppEnabled) {
      familyEmailRowValidateSig.current = {};
      setFamilyEmailStatus({});
      return;
    }

    if (!familyLoginAllowed) {
      return;
    }

    const timers = [];
    const liveKeys = new Set(familyEmails.map((row) => row.key));
    Object.keys(familyEmailRowValidateSig.current).forEach((key) => {
      if (!liveKeys.has(key)) {
        delete familyEmailRowValidateSig.current[key];
      }
    });

    familyEmails.forEach((row) => {
      const emailEditable = !row.baselineEmail || row.editMode;
      const typed = (row.email || "").trim();
      const rowSig = `${typed}|${emailEditable ? 1 : 0}|${
        row.baselineEmail || ""
      }`;

      // Only validate rows that actually changed (avoids re-checking siblings on Add)
      if (familyEmailRowValidateSig.current[row.key] === rowSig) {
        return;
      }
      familyEmailRowValidateSig.current[row.key] = rowSig;

      if (!emailEditable) {
        familyEmailValidateSeqByKey.current[row.key] =
          (familyEmailValidateSeqByKey.current[row.key] || 0) + 1;
        setFamilyEmailStatus((prev) => {
          if (!prev[row.key]) return prev;
          const next = { ...prev };
          delete next[row.key];
          return next;
        });
        return;
      }

      if (!typed) {
        familyEmailValidateSeqByKey.current[row.key] =
          (familyEmailValidateSeqByKey.current[row.key] || 0) + 1;
        setFamilyEmailStatus((prev) => ({
          ...prev,
          [row.key]: {
            userExist: false,
            validationMessage: "",
            successMessage: "",
            validating: false,
          },
        }));
        return;
      }

      const formatError = getFamilyEmailFormatError(typed);
      if (formatError) {
        familyEmailValidateSeqByKey.current[row.key] =
          (familyEmailValidateSeqByKey.current[row.key] || 0) + 1;
        setFamilyEmailStatus((prev) => ({
          ...prev,
          [row.key]: {
            userExist: false,
            validationMessage: formatError,
            successMessage: "",
            validating: false,
          },
        }));
        return;
      }

      const baseline = (row.baselineEmail || "").trim();
      const isEditingExistingEmail = Boolean(baseline) && row.editMode;
      const emailChangedFromLoaded = !baseline || typed !== baseline;
      if (baseline && (!isEditingExistingEmail || !emailChangedFromLoaded)) {
        familyEmailValidateSeqByKey.current[row.key] =
          (familyEmailValidateSeqByKey.current[row.key] || 0) + 1;
        setFamilyEmailStatus((prev) => ({
          ...prev,
          [row.key]: {
            userExist: false,
            validationMessage: "",
            successMessage: "",
            validating: false,
          },
        }));
        return;
      }

      const duplicateInList = familyEmails.some(
        (other) =>
          other.key !== row.key &&
          (other.email || "").trim().toLowerCase() === typed.toLowerCase()
      );
      if (duplicateInList) {
        familyEmailValidateSeqByKey.current[row.key] =
          (familyEmailValidateSeqByKey.current[row.key] || 0) + 1;
        setFamilyEmailStatus((prev) => ({
          ...prev,
          [row.key]: {
            userExist: false,
            validationMessage: "This email is already in the list.",
            successMessage: "",
            validating: false,
          },
        }));
        return;
      }

      setFamilyEmailStatus((prev) => ({
        ...prev,
        [row.key]: {
          userExist: false,
          validationMessage: "",
          successMessage: "",
          validating: true,
        },
      }));

      const seq = (familyEmailValidateSeqByKey.current[row.key] || 0) + 1;
      familyEmailValidateSeqByKey.current[row.key] = seq;

      const timer = setTimeout(async () => {
        try {
          const validateRes = await apiPostRequest(
            URL_SP_VALIDATE_FAMILY_MEMBER,
            { email: typed }
          );
          if (seq !== familyEmailValidateSeqByKey.current[row.key]) return;
          const exists = parseFamilyMemberUserExist(validateRes);
          setFamilyEmailStatus((prev) => ({
            ...prev,
            [row.key]: {
              userExist: exists,
              validationMessage: "",
              successMessage: exists
                ? "An account with this email already exists. It will be linked on save."
                : "This email is available. An invite will be sent so they can set their own password.",
              validating: false,
            },
          }));
        } catch (e) {
          if (seq !== familyEmailValidateSeqByKey.current[row.key]) return;
          setFamilyEmailStatus((prev) => ({
            ...prev,
            [row.key]: {
              userExist: false,
              validationMessage:
                e?.message || "Could not verify this email. Please try again.",
              successMessage: "",
              validating: false,
            },
          }));
        }
      }, FAMILY_EMAIL_DEBOUNCE_MS);

      timers.push(timer);
    });

    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [familyAppEnabled, familyEmails, familyEmailsValidationKey, familyLoginAllowed]);

  useEffect(() => {
    setWorkers(workersList);
    setSupportCoordinators(supportCoordinatorsList);
    setAlliedHealthers(alliedHealthWorkersList);
  }, [workersList, supportCoordinatorsList, alliedHealthWorkersList]);

  useEffect(() => {
    if (isLoading || !user) {
      return;
    }
    reset(user);
  }, [user, isLoading, reset]);

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  const closeFamilyMemberConfirm = () => {
    if (familyEmailBusyKey) return;
    setFamilyMemberConfirm(null);
  };

  const applyFamilyLinkedEmails = (linked) => {
    if (!Array.isArray(linked)) return;
    const members = pickFamilyMembersFromPayload(
      { family_member_emails: linked },
      { allowLegacySingle: false }
    );
    const { uniqueEmails, rows } = buildFamilyEmailRowsFromList(
      members.length ? members : linked
    );
    setBaselineFamilyEmails(uniqueEmails);
    setFamilyEmails(rows);
    setFamilyEmailStatus({});
  };

  const resendFamilyAppInvite = async ({ email, busyKey } = {}) => {
    if (familyEmailBusyKey || !uuid) return;
    const key = busyKey || email || "participant-resend";
    setFamilyEmailBusyKey(key);
    try {
      const payload = { pt_uuid: uuid };
      if (email) {
        payload.email = email;
      }
      const res = await apiPostRequest(URL_SP_RESEND_FAMILY_APP_INVITE, payload);
      const data = res?.data?.data ?? res?.data ?? {};
      if (Array.isArray(data.family_member_emails)) {
        applyFamilyLinkedEmails(data.family_member_emails);
      }
      if (
        data.participant_app_login_status === "active" ||
        data.participant_app_login_status === "pending"
      ) {
        setParticipantAppInviteStatus(data.participant_app_login_status);
      }
      if (data.participant_app_can_resend_invite === false) {
        setParticipantAppCanResendInvite(false);
      }
      toast.success("Invitation email sent.");
    } catch (e) {
      toast.error(e?.message || "Could not resend the invitation.");
    } finally {
      setFamilyEmailBusyKey(null);
    }
  };

  const confirmFamilyMemberAction = async () => {
    if (!familyMemberConfirm || familyEmailBusyKey) return;

    const { mode, rowKey, email, oldEmail, newEmail } = familyMemberConfirm;
    setFamilyEmailBusyKey(rowKey);

    try {
      if (mode === "remove") {
        const unlinkRes = await apiPostRequest(URL_SP_UNLINK_FAMILY_MEMBER, {
          pt_uuid: uuid,
          email: (email || "").trim(),
        });
        const linked =
          unlinkRes?.data?.data?.family_member_emails ??
          unlinkRes?.data?.family_member_emails ??
          null;
        if (Array.isArray(linked)) {
          applyFamilyLinkedEmails(linked);
        } else {
          const target = (email || "").trim().toLowerCase();
          setBaselineFamilyEmails((prev) =>
            (prev || []).filter(
              (item) => item.trim().toLowerCase() !== target
            )
          );
          setFamilyEmails((prev) => {
            const next = prev.filter((item) => item.key !== rowKey);
            return next.length > 0 ? next : [createFamilyEmailEntry()];
          });
          setFamilyEmailStatus((prev) => {
            const next = { ...prev };
            delete next[rowKey];
            return next;
          });
          delete familyEmailRowValidateSig.current[rowKey];
        }
        toast.success("Family member removed.");
      } else if (mode === "update") {
        const updateRes = await apiPostRequest(URL_SP_UPDATE_FAMILY_MEMBER, {
          pt_uuid: uuid,
          old_email: (oldEmail || "").trim(),
          new_email: (newEmail || "").trim(),
        });
        const linked =
          updateRes?.data?.data?.family_member_emails ??
          updateRes?.data?.family_member_emails ??
          null;
        if (Array.isArray(linked)) {
          applyFamilyLinkedEmails(linked);
        } else {
          const nextEmail = (newEmail || "").trim();
          const prevEmail = (oldEmail || "").trim();
          familyEmailValidateSeqByKey.current[rowKey] =
            (familyEmailValidateSeqByKey.current[rowKey] || 0) + 1;
          familyEmailRowValidateSig.current[
            rowKey
          ] = `${nextEmail}|0|${nextEmail}`;
          setBaselineFamilyEmails((prev) => {
            const next = (prev || []).filter(
              (item) =>
                item.trim().toLowerCase() !== prevEmail.toLowerCase()
            );
            next.push(nextEmail);
            return next;
          });
          setFamilyEmails((prev) =>
            prev.map((item) =>
              item.key === rowKey
                ? {
                    ...item,
                    email: nextEmail,
                    baselineEmail: nextEmail,
                    editMode: false,
                    inviteStatus: "pending",
                  }
                : item
            )
          );
          setFamilyEmailStatus((prev) => {
            const next = { ...prev };
            delete next[rowKey];
            return next;
          });
        }
        toast.success("Family member email updated.");
      }
      setFamilyMemberConfirm(null);
    } catch (e) {
      toast.error(
        e?.message ||
          (familyMemberConfirm?.mode === "update"
            ? "Could not update this family member."
            : "Could not remove this family member.")
      );
    } finally {
      setFamilyEmailBusyKey(null);
    }
  };

  const handlePlanByChange = (selectedOption) => {
    setPlanBy(selectedOption);
    setValue("planBy", selectedOption, { shouldValidate: true });
    if (selectedOption?.value !== "planManaged") {
      setValue("planManagerName", "");
      setValue("planManagerEmail", "");
      setValue("planManagerCompany", "");
    }
  };
  const addBlockDiv = () => {
    if (
      primaryDisability &&
      primaryDisability !== null &&
      primaryDisability.value === "other" &&
      secondaryDisability &&
      secondaryDisability !== null &&
      secondaryDisability.value !== "other"
    ) {
      return <div className='block' />;
    }

    if (
      secondaryDisability &&
      secondaryDisability !== null &&
      secondaryDisability.value === "other" &&
      primaryDisability &&
      primaryDisability !== null &&
      primaryDisability.value !== "other"
    ) {
      return <div className='block' />;
    }

    return <></>;
  };

  useEffect(() => {
    const getManagersList = async () => {
      try {
        setLoader(true);
        const res = await api.getTeamLeadManagerAndRegions(1);
        let regions = Array.isArray(res?.data?.regions) ? res?.data?.regions : [];

        if (
          regions.length === 0 &&
          roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])
        ) {
          const fallbackRes = await apiPostRequest(
            `${URL_TEAM_LEAD_GET_REGION_LIST}?per_page=1000&page=1`,
            { search: "" }
          );
          const fallbackRegions = fallbackRes?.data?.data?.regions;
          regions = Array.isArray(fallbackRegions)
            ? fallbackRegions
            : Array.isArray(fallbackRegions?.data)
            ? fallbackRegions?.data
            : [];
        }

        setRegionList(regions);
      } catch (error) {
        console.log("error while fetching regions", error);
        setRegionList([]);
      } finally {
        setLoader(false);
      }
    };
    getManagersList();
  }, []);

  useEffect(() => {
    if (settingData) {
      setSelectedItems(...settingData?.regions);
    }
    fetchLabels(); // Ensure labels are fetched during initialization
  }, []);

  const validateStartDate = (startDate) => {
    if (!startDate) return true;
    if (!planEndDate) return true;
    return new Date(startDate) < new Date(planEndDate);
  };

  const validateEndDate = (endDate) => {
    if (!endDate) return true;
    if (!planStartDate) return true;
    return new Date(endDate) > new Date(planStartDate);
  };

  const [questions, setQuestions] = useState([]);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);

  const fetchShiftEndQuestions = async () => {
    setIsLoadingQuestions(true);
    try {
       const isAdminOrManager = roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]);
                              const endpoint = isAdminOrManager
                                  ? `${URL_ROSTERING_SHIFT_END_QUESTION}`
                                  : `${URL_ROSTERING_SHIFT_END_QUESTION_FOR_WORKER}/${uuid}`;
      const response = await apiGetRequest(endpoint);
      if (response?.data && Array.isArray(response?.data?.show_questions)) {
        const formattedQuestions = response?.data?.show_questions?.map(
          (question) => ({
            id: question?.id,
            question: question?.question,
            type: question?.answer_type || "text",
            options: question?.options || [],
            required: false,
          })
        );
        setQuestions(formattedQuestions);
      }
    } catch (error) {
    //   toast.error("Failed to load questions. Please try again.");
      setQuestions([]);
    } finally {
      setIsLoadingQuestions(false);
    }
  };

  useEffect(() => {
    fetchShiftEndQuestions();
  }, []);

  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const canEditShiftEndQuestions = roleAccess([
    USER_ROLE.Sp_Admin,
    USER_ROLE.Sp_manager,
  ]);
  const handleQuestionToggle = (question) => {
    const isSelected = selectedQuestions.find((q) => q.id === question.id);

    if (isSelected) {
      setSelectedQuestions(
        selectedQuestions.filter((q) => q.id !== question.id)
      );
    } else {
      if (selectedQuestions.length < 8) {
        setSelectedQuestions([
          ...selectedQuestions,
          { ...question, is_mandatory: false },
        ]);
      }
    }
  };

  const handleQuestionRemove = (questionId) => {
    setSelectedQuestions(selectedQuestions.filter((q) => q.id !== questionId));
  };

  const handleQuestionMandatoryChange = (questionId, value) => {
    setSelectedQuestions((current) =>
      current.map((question) =>
        question.id === questionId
          ? { ...question, is_mandatory: value }
          : question
      )
    );
  };

  const renderMandatoryToggle = (question) => (
    <div
      className='flex items-center gap-2'
      onClick={(event) => event.stopPropagation()}
    >
      <span className='text-xs font-medium text-gray-600'>Mandatory</span>
      <SwitchWithIcon
        isSmall
        checked={parseBooleanVal(question?.is_mandatory)}
        onChange={(value) => handleQuestionMandatoryChange(question.id, value)}
        disabled={!canEditShiftEndQuestions}
        tooltip='Worker must answer this before the shift can end'
      />
    </div>
  );

  useEffect(() => {
    if (settingData && settingData?.participant_questions) {
      const savedRows = settingData.participant_questions;
      const savedQuestions = questions
        .filter((question) =>
          savedRows.some((row) => row.question_id === question.id)
        )
        .map((question) => {
          const saved = savedRows.find((row) => row.question_id === question.id);
          return {
            ...question,
            is_mandatory: parseBooleanVal(saved?.is_mandatory),
          };
        });
      setSelectedQuestions(savedQuestions);
    }
  }, [settingData, questions]);

  return (
    <div className='px-4 sm:px-6 py-4 sm:py-6'>
      <div className='md:grid md:gap-6'>
        {settingLoading && !settingData ? (
          <div className='col-span-3 h-screen'>
            <CircularLoader
              classes='h-full flex justify-center items-center'
              classloader='loader-l'
            />
          </div>
        ) : (
          <div className='mt-5 md:mt-0 md:col-span-2'>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='bg-white border border-gray-200 shadow-lg sm:rounded-xl sm:overflow-hidden'>
                <div className='px-4 sm:px-6 py-6 bg-white space-y-6'>
                  {/* Photo Upload Section */}
                  <div className='pb-6 border-b border-gray-200'>
                    <label className='block text-sm font-semibold text-gray-700 mb-3'>
                      Photo
                    </label>
                    <div className='flex items-center gap-4'>
                      <div className='flex-shrink-0'>
                        {file ? (
                          <img
                            className='object-cover w-20 h-20 rounded-full ring-4 ring-gray-100'
                            src={file}
                            alt='Profile'
                          />
                        ) : (
                          <img
                            onError={(e) =>
                              handleImageError(
                                e,
                                settingData.first_name,
                                settingData.last_name || " "
                              )
                            }
                            className='object-cover w-20 h-20 rounded-full ring-4 ring-gray-100'
                            src={
                              settingData && settingData.profile_picture
                                ? baseURLImage(settingData.profile_picture)
                                : getNameProfile(
                                    settingData.first_name,
                                    settingData.last_name || " "
                                  )
                            }
                            alt='Profile'
                          />
                        )}
                      </div>
                      <div className='flex-1'>
                        <label
                          htmlFor='file-upload'
                          className='inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors cursor-pointer'
                        >
                          <svg className='w-4 h-4 mr-2' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                          </svg>
                          Upload Image
                          <input
                            id='file-upload'
                            name='file-upload'
                            type='file'
                            className='sr-only'
                            accept='image/*'
                            onChange={handleChange}
                          />
                        </label>
                        <p className='text-xs text-gray-500 mt-2'>
                          File size must be less than 2MB. Supported formats: JPEG, PNG
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Personal Information Section */}
                  <div>
                    <h3 className='text-base font-semibold text-gray-900 mb-4'>Personal Information</h3>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 [&>div]:min-w-0'>
                    <div>
                      <label
                        htmlFor='f_name'
                        className='capitalize block text-sm font-medium text-gray-700'
                      >
                        First Name
                      </label>
                      <div className='mt-1'>
                        <input
                          maxLength={50}
                          type='text'
                          name='f_name'
                          id='f_name'
                          className='did-floating-input capitalize'
                          {...register("firstName", {
                            required: true,
                            maxLength: 50,
                          })}
                        />
                        {errors.firstName && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor='f_name'
                        className='capitalize block text-sm font-medium text-gray-700'
                      >
                        Last Name
                      </label>
                      <div className='mt-1'>
                        <input
                          maxLength={50}
                          type='text'
                          name='f_name'
                          id='f_name'
                          className='did-floating-input capitalize'
                          {...register("lastName", {
                            required: true,
                            maxLength: 50,
                          })}
                        />
                        {errors.lastName && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT.DOB
                    ) && (
                      <div>
                        <label
                          htmlFor=''
                          className='block text-sm font-medium text-gray-700'
                        >
                          Date of Birth
                        </label>
                        <div className='mt-1'>
                          <Controller
                            name='dob'
                            control={control}
                            rules={{ required: false }}
                            render={({ field, fieldState }) => (
                              <DateRangeWithRegister
                                isSingleDate
                                field={field}
                                fieldState={fieldState}
                                isClearable
                                maxDate={new Date()}
                                placeholder='Select Birth Date'
                                showCalendarIcon
                              />
                            )}
                          />
                          {/* <input
                            type='date'
                            name=''
                            id=''
                            // validate
                            className='did-floating-input'
                            {...register("dob", {
                              // required: true
                              pattern: validateCurrentDate(
                                moment(watchAllFields.dob),
                                moment(new Date()),
                                ["past", "present"],
                                true
                              ),
                            })}
                          /> */}
                          {errors?.dob?.type === "required" && (
                            <span className='text-red-500'>
                              This field is required
                            </span>
                          )}
                          {errors?.dob?.type === "pattern" && (
                            <span className='text-sm text-red-500'>
                              {validateCurrentDate(
                                moment(watchAllFields.dob),
                                moment(new Date()),
                                ["past", "present"],
                                false
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT.NDIS_NUMBER
                    ) && (
                      <div>
                        <label
                          htmlFor=''
                          className='block text-sm font-medium text-gray-700'
                        >
                          NDIS Number <span className='font-normal text-gray-500'>(max 15)</span>
                        </label>
                        <div className='mt-1'>
                          <input
                            type='number'
                            name=''
                            id=''
                            className='did-floating-input'
                            maxLength={15}
                            {...register("ndisNumber", {
                              // required: true,
                              pattern: {
                                value: /^(43|5|6)/,
                                message:
                                  "NDIS number should start with either '43', '5' or '6'",
                              },
                              onChange: (e) => {
                                const sanitizedValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                e.target.value = sanitizedValue.slice(0, 15);
                              },
                            })}
                          />
                          {errors.required
                            ? errors.ndisNumber && (
                                <span className='text-red-500'>
                                  This field is required
                                </span>
                              )
                            : errors?.ndisNumber?.type === "pattern" && (
                                <span className='text-red-500'>
                                  {errors?.ndisNumber?.message}
                                </span>
                              )}
                        </div>
                      </div>
                    )}
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT.NDIS_NUMBER
                    ) && (
                      <div>
                        <label
                          htmlFor='invoiceReferenceNumberXero'
                          className='block text-sm font-medium text-gray-700'
                        >
                          Invoice Reference Number (XERO)
                        </label>
                        <div className='mt-1'>
                          <input
                            type='text'
                            id='invoiceReferenceNumberXero'
                            className='did-floating-input'
                            placeholder={
                              watchAllFields.ndisNumber
                                ? `Defaults to NDIS Number (${watchAllFields.ndisNumber})`
                                : "Defaults to NDIS Number when empty"
                            }
                            {...register("invoiceReferenceNumberXero", {
                              maxLength: {
                                value: 255,
                                message: "Maximum 255 characters allowed",
                              },
                            })}
                          />
                          {errors?.invoiceReferenceNumberXero?.type ===
                            "maxLength" && (
                            <span className='text-red-500'>
                              {errors?.invoiceReferenceNumberXero?.message}
                            </span>
                          )}
                          <p className='mt-1 text-xs text-gray-500'>
                            Used as the Xero invoice reference. Leave empty to
                            use the NDIS Number.
                          </p>
                        </div>
                      </div>
                    )}
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT.PRIMARY_PHONE
                    ) && (
                      <div>
                        <label
                          htmlFor='phone'
                          className='block text-sm font-medium text-gray-700'
                        >
                          Primary Phone Number
                        </label>
                        <div className='mt-1'>
                          <input
                            type='number'
                            // minLength={10}
                            maxLength={10}
                            name='phone'
                            id='phone'
                            className='did-floating-input'
                            {...register("phone", {
                              // required: true,
                              // minLength: 10,
                              maxLength: 10,
                              pattern: REGEX_PHONE_NUMBER,
                              onChange: (e) => {
                                const sanitizedValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                const formattedValue = sanitizedValue.slice(
                                  0,
                                  10
                                );
                                e.target.value = formattedValue;
                              },
                            })}
                          />
                          {/* {errors?.phone?.type === "required" ? (
                          errors.phone && (
                            <span className="text-red-500">
                              This field is required
                            </span>
                          )
                        ) : ( */}
                          <>
                            {errors.phone?.type === "pattern" && (
                              <span className='text-red-500'>
                                {/* Phone number must start with 04, 1300 or 1800 */}
                                Please enter a valid phone number!
                              </span>
                            )}
                            {/* {errors.phone?.type === "maxLength" && (
                            <span className="text-red-500">
                              Please enter a valid phone number with the max
                              length of 10
                            </span>
                          )} */}
                            {errors.phone?.type === "minLength" && (
                              <span className='text-red-500'>
                                Please enter a valid phone number with the min
                                length of 10
                              </span>
                            )}
                          </>
                          {/* )} */}
                        </div>
                      </div>
                    )}
                    <div className='md:col-span-2'>
                      <FormProvider
                        {...{
                          register,
                          setValue,
                          watch,
                          control,
                          formState: { errors },
                        }}
                      >
                        <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
                          {roleAccess(
                            [],
                            PERMISSION_KEYS.PARTICIPANT,
                            PERMISSION_KEYS_CHILDREN.PARTICIPANT.PRIMARY_EMAIL
                          ) && (
                            <div>
                              <label
                                htmlFor='participant-primary-email'
                                className='block text-sm font-medium text-gray-700'
                              >
                                Primary Email Address
                                {participantAppEnabled ? (
                                  <span className='text-red-500'> *</span>
                                ) : null}
                              </label>
                              <div className='mt-1'>
                                <input
                                  type='email'
                                  name='primary_email'
                                  id='participant-primary-email'
                                  className='did-floating-input'
                                  {...register("primary_email", {
                                    required: participantAppEnabled,
                                    pattern: EMAIL_REGEX_EXP,
                                  })}
                                />
                                {errors?.primary_email?.type === "required" ? (
                                  <span className='text-red-500'>
                                    This field is required
                                  </span>
                                ) : errors?.primary_email?.type ===
                                  "pattern" ? (
                                  <span className='text-red-500'>
                                    Invalid email address
                                  </span>
                                ) : null}
                                {participantAppEnabled &&
                                participantEmailStatus.validating &&
                                !participantEmailStatus.validationMessage &&
                                !participantEmailStatus.successMessage ? (
                                  <p
                                    className='mt-1 text-sm text-slate-500'
                                    aria-live='polite'
                                  >
                                    Checking email…
                                  </p>
                                ) : null}
                                {participantAppEnabled &&
                                participantEmailStatus.successMessage &&
                                !participantEmailStatus.validating &&
                                !participantEmailStatus.validationMessage ? (
                                  <p
                                    className={`mt-1 text-sm ${
                                      participantEmailStatus.userExist
                                        ? "text-amber-800"
                                        : "text-emerald-800"
                                    }`}
                                    aria-live='polite'
                                  >
                                    {participantEmailStatus.successMessage}{" "}
                                    <span className='text-gray-500'>
                                      Save Changes emails the invite link.
                                    </span>
                                  </p>
                                ) : null}
                                {participantAppEnabled &&
                                participantEmailStatus.validationMessage ? (
                                  <p
                                    className='mt-1 text-sm text-red-600'
                                    aria-live='polite'
                                  >
                                    {participantEmailStatus.validationMessage}
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          )}
                          <div
                            className={
                              roleAccess(
                                [],
                                PERMISSION_KEYS.PARTICIPANT,
                                PERMISSION_KEYS_CHILDREN.PARTICIPANT
                                  .PRIMARY_EMAIL
                              )
                                ? ""
                                : "sm:col-span-2"
                            }
                          >
                            <AddressAutocomplete
                              customNames={{
                                street_address: "address",
                                suburb: "suburb",
                                state: "state",
                                postcode: "postcode",
                                lat: "lat",
                                lng: "lng",
                              }}
                              addressId='participant-address-input'
                              isStateName={false}
                            >
                              <div>
                                <label
                                  htmlFor='participant-address-input'
                                  className='block text-sm font-medium text-gray-700'
                                >
                                  Street Address
                                </label>
                                <div className='relative mt-1'>
                                  <input
                                    type='text'
                                    name='address'
                                    id='participant-address-input'
                                    className='did-floating-input '
                                    {...register("address", {
                                      maxLength: 254,
                                    })}
                                  />
                                  {errors.address && (
                                    <span className='text-red-500'>
                                      This field is required
                                    </span>
                                  )}
                                </div>
                                <p className='text-xs text-gray-500 mt-1'>
                                  Start typing an address and select from
                                  suggestions
                                </p>
                              </div>
                            </AddressAutocomplete>
                          </div>

                          <div>
                            <label
                              htmlFor='suburb'
                              className='block text-sm font-medium text-gray-700'
                            >
                              Suburb
                            </label>
                            <div className='relative mt-1'>
                              <input
                                type='text'
                                name='suburb'
                                id='suburb'
                                className='did-floating-input '
                                {...register("suburb", {
                                  maxLength: 254,
                                })}
                              />
                              {errors.suburb && (
                                <span className='text-red-500'>
                                  This field is required
                                </span>
                              )}
                            </div>
                          </div>
                          <div>
                            <label className='block text-sm font-medium text-gray-700 mb-1'>
                              State
                            </label>
                            <SelectOption
                              key={`state-select-${stateValue || "empty"}`}
                              cssClass='truncate'
                              isRequired={true}
                              register={register}
                              setValue={setValue}
                              name='state'
                              isSearch={false}
                              data={STATES_LIST}
                              selectedOption={selectedStateOption}
                              errorMessage={
                                errors?.state?.type === "required" ? (
                                  <div className='text-sm text-red-500'>
                                    This field is required!
                                  </div>
                                ) : null
                              }
                            />
                          </div>
                          <div>
                            <label
                              htmlFor='postcode'
                              className='block text-sm font-medium text-gray-700'
                            >
                              Postcode
                            </label>
                            <div className='relative mt-1'>
                              <input
                                type='number'
                                name='postcode'
                                id='postcode'
                                minLength={4}
                                maxLength={4}
                                className='did-floating-input '
                                {...register("postcode", {
                                  maxLength: 4,
                                  minLength: 4,
                                  onChange: (e) => {
                                    e.target.value = e.target.value
                                      .toString()
                                      .slice(0, 4);
                                  },
                                })}
                              />
                              {errors?.postcode?.type === "maxLength" ? (
                                <span className='text-red-500 text-sm'>
                                  Postcode must be 4 digits
                                </span>
                              ) : errors?.postcode?.type === "minLength" ? (
                                <span className='text-red-500 text-sm'>
                                  Postcode must be 4 digits
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <input type='hidden' {...register("lat")} />
                          <input type='hidden' {...register("lng")} />
                        </div>
                      </FormProvider>
                    </div>
                    </div>
                  </div>

                  {/* Additional Information Section */}
                  <div className='pt-6 border-t border-gray-200'>
                    <h3 className='text-base font-semibold text-gray-900 mb-4'>Additional Information</h3>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6'>
                    <div className='md:col-span-2'>
                      <label
                        htmlFor='comment'
                        className='block text-sm font-medium text-gray-700'
                      >
                        Quick Snapshot
                      </label>
                      <div className='mt-1'>
                        <textarea
                          rows={3}
                          name='comment'
                          id='comment'
                          className='px-4 py-2 border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full text-sm rounded-lg resize-none'
                          {...register("quickSnapshot", {
                            //  required: true
                          })}
                        />
                        {errors.quickSnapshot && (
                          <span className='text-red-500 text-sm mt-1 block'>
                            This field is required
                          </span>
                        )}
                      </div>
                    </div>

                    <div>
                      <label
                        htmlFor=''
                        className='block text-sm font-medium text-gray-700'
                      >
                        Status Description{" "}
                        <span className='text-gray-500 text-xs font-normal'>
                          (max. 256)
                        </span>
                      </label>
                      <div className='mt-1'>
                        <input
                          type='text'
                          name=''
                          id=''
                          className='did-floating-input'
                          {...register("status_description", {
                            // required: true,
                            maxLength: 254,
                          })}
                        />
                        {errors.status_description && (
                          <span className='text-red-500 text-sm mt-1 block'>Limit exceeded.</span>
                        )}
                      </div>
                    </div>
                    </div>
                  </div>

                  {/* Emergency Contact Section */}
                  <div className='pt-6 border-t border-gray-200'>
                    <h3 className='text-base font-semibold text-gray-900 mb-4'>Emergency Contact</h3>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6'>

                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT
                        .EMERGENCY_CONTACT_NAME
                    ) && (
                      <div>
                        <label
                          htmlFor='name'
                          className='block text-sm font-medium text-gray-700'
                        >
                          Emergency Contact Name
                        </label>
                        <div className='mt-1'>
                          <input
                            type='text'
                            name='name'
                            id='name'
                            className='did-floating-input'
                            {...register("emergencyContactName", {
                              // required: true,
                              maxLength: 254,
                            })}
                          />
                          {errors.emergencyContactName && (
                            <span className='text-red-500'>
                              This field is required
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT
                        .EMERGENCY_CONTACT_PHONE
                    ) && (
                      <div>
                        <label
                          htmlFor='number'
                          className='block text-sm font-medium text-gray-700'
                        >
                          Emergency Contact Number
                        </label>
                        <div className='mt-1'>
                          <input
                            type='number'
                            // minLength={10}
                            maxLength={10}
                            name='emergencyContactPhone'
                            id='emergencyContactPhone'
                            className='did-floating-input'
                            {...register("emergencyContactPhone", {
                              // required: true,
                              // minLength: 10,
                              maxLength: 10,
                              pattern: REGEX_PHONE_NUMBER,
                              onChange: (e) => {
                                const sanitizedValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                const formattedValue = sanitizedValue.slice(
                                  0,
                                  10
                                );
                                e.target.value = formattedValue;
                              },
                            })}
                          />
                          {errors?.emergencyContactPhone?.type ===
                          "required" ? (
                            errors.emergencyContactPhone && (
                              <span className='text-red-500'>
                                Please enter a valid phone number with the max
                                length of 10
                              </span>
                            )
                          ) : (
                            <>
                              {errors.emergencyContactPhone?.type ===
                                "pattern" && (
                                <span className='text-red-500'>
                                  {/* Phone number must start with 04, 1300 or 1800 */}
                                  Please enter a valid phone number!
                                </span>
                              )}
                              {errors.emergencyContactPhone?.type ===
                                "minLength" && (
                                <span className='text-red-500'>
                                  Please enter a valid phone number with the min
                                  length of 10
                                </span>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                    </div>
                  </div>

                  {/* Disability Information Section */}
                  <div className='pt-6 border-t border-gray-200'>
                    <h3 className='text-base font-semibold text-gray-900 mb-4'>Disability Information</h3>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6'>
                    {/* Primary Disability */}
                    <div>
                      <div className='hidden'>
                        <select
                          {...register("primary_disability", {
                            // required: true,
                          })}
                          name='primary_disability'
                          id=''
                          className='hidden did-floating-input'
                        />
                      </div>
                      <label className='mb-1 block text-sm font-medium text-gray-700'>
                        Primary Disability
                      </label>
                      <SelectOption
                        // isMulti={true}
                        isSearch={false}
                        data={PRIMARY_DISABILITY_OPTIONS}
                        selectedOption={primaryDisability}
                        handleChange={setPrimaryDisability}
                      />
                      {!primaryDisability &&
                        errors?.primary_disability?.type === "required" && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                    </div>
                    {primaryDisability &&
                      primaryDisability !== null &&
                      primaryDisability.value === "other" && (
                        <div>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'
                          >
                            Other Primary Disability
                          </label>
                          <div className='mt-1'>
                            <input
                              type='text'
                              name=''
                              id=''
                              className='did-floating-input'
                              {...register("primary_disability", {
                                required: true,
                                maxLength: 254,
                              })}
                            />
                            {primaryDisability &&
                              errors?.primary_disability?.type ===
                                "required" && (
                                <span className='text-red-500'>
                                  This field is required
                                </span>
                              )}
                          </div>
                        </div>
                      )}

                    {/* Secondary Disability */}
                    <div>
                      <div className='hidden'>
                        <select
                          {...register("secondary_disability", {
                            // required: true,
                          })}
                          name='secondary_disability'
                          id=''
                          className='hidden did-floating-input'
                        />
                      </div>
                      <label className='mb-1 block text-sm font-medium text-gray-700'>
                        Secondary Disability
                      </label>
                      <SelectOption
                        // isMulti={true}
                        isSearch={false}
                        data={PRIMARY_DISABILITY_OPTIONS}
                        selectedOption={secondaryDisability}
                        handleChange={setSecondaryDisability}
                      />
                      {!secondaryDisability &&
                        errors?.secondary_disability?.type === "required" && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                    </div>
                    {secondaryDisability &&
                      secondaryDisability !== null &&
                      secondaryDisability.value === "other" && (
                        <div>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'
                          >
                            Other Secondary Disability
                          </label>
                          <div className='mt-1'>
                            <input
                              type='text'
                              name=''
                              id=''
                              className='did-floating-input'
                              {...register("secondary_disability", {
                                required: true,
                                maxLength: 254,
                              })}
                            />
                            {secondaryDisability &&
                              errors?.secondary_disability?.type ===
                                "required" && (
                                <span className='text-red-500'>
                                  This field is required
                                </span>
                              )}
                          </div>
                        </div>
                      )}

                    {/* <div>
                      <label
                        htmlFor=''
                        className='block text-sm font-medium text-gray-700'
                      >
                        Email for Invoice
                      </label>
                      <div className='mt-1'>
                        <input
                          type='text'
                          name=''
                          id=''
                          className='did-floating-input'
                          {...register("email", {
                            // required: false,
                            maxLength: 254,

                            pattern: EMAIL_REGEX_EXP,
                          })}
                        />
                        {errors.required
                          ? errors.email && (
                              <span className='text-red-500'>
                                This field is required
                              </span>
                            )
                          : errors?.email?.type === "pattern" && (
                              <span className='text-red-500'>
                                Invalid email address
                              </span>
                            )}
                      </div>
                    </div> */}
                    <div className='col-span-1'>
                      <div className=''>
                        <label className='block text-sm font-medium text-gray-700 mb-1'>
                          Gender
                        </label>
                        <SelectOption
                          cssClass='truncate'
                          isRequired={false}
                          register={register}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          name='gender'
                          isSearch={false}
                          data={GenderOptions}
                          useMenuPortal={true}
                          selectedOption={GenderOptions.find(
                            (x) => x.value === watchAllFields?.gender
                          )}
                        />
                      </div>
                    </div>
                    </div>
                  </div>

                  {/* Additional Settings Section */}
                  <div className='pt-6 border-t border-gray-200'>
                    <h3 className='text-base font-semibold text-gray-900 mb-4'>Additional Settings</h3>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6'>
                    <div>
                      <label
                        htmlFor='location'
                        className='block text-sm font-medium text-gray-700'
                      >
                        Timezone
                      </label>
                      <div className='relative mt-1'>
                        <select
                          id='location'
                          name='location'
                          className='shadow-sm border mt-1 block w-full pl-8 pr-10 py-2 text-sm border-gray-300 focus:outline-none focus:bg-[#4b6bb710] focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md'
                          defaultValue=''
                          {...register("timeZone", {
                            //  required: true
                          })}
                        >
                          <option value={"Australia/Adelaide"}>Australia/Adelaide</option>
                          <option value={"Australia/Brisbane"}>Australia/Brisbane</option>
                          <option value={"Australia/Broken_Hill"}>Australia/Broken_Hill</option>
                          <option value={"Australia/Darwin"}>Australia/Darwin</option>
                          <option value={"Australia/Eucla"}>Australia/Eucla</option>
                          <option value={"Australia/Hobart"}>Australia/Hobart</option>
                          <option value={"Australia/Lindeman"}>Australia/Lindeman</option>
                          <option value={"Australia/Lord_Howe"}>Australia/Lord_Howe</option>
                          <option value={"Australia/Melbourne"}>Australia/Melbourne</option>
                          <option value={"Australia/Perth"}>Australia/Perth</option>
                          <option value={"Australia/Sydney"}>Australia/Sydney</option>
                        </select>
                        {errors.timeZone && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                        <div className='absolute top-1/2 -translate-y-1/2 left-3'>
                          <AiOutlineClockCircle />
                        </div>
                      </div>
                    </div>
                    {/* <SelectBox /> */}
                    <div>
                      <div className='hidden'>
                        <select
                          {...register("plan", {
                            value: false,
                            // required: true,
                          })}
                          name='plan'
                          id=''
                          className='hidden did-floating-input'
                          defaultValue={false}
                        />
                      </div>
                      <label className='mb-1 block text-sm font-medium text-gray-700'>
                        Plan Managed By
                      </label>
                      <SelectOption
                        isSearch={false}
                        // isMulti={true}
                        data={planManagedByOptions}
                        selectedOption={planBy}
                        handleChange={setPlanBy}
                      />
                      {errors.plan && (
                        <span className='text-red-500'>
                          This field is required
                        </span>
                      )}
                    </div>

                    {planBy?.value === "planManaged" && (
                      <>
                        <div>
                          <label className='mb-1 block text-sm font-medium text-gray-700'>
                            Plan Manager Name
                          </label>
                          <input
                            type='text'
                            name='plan_manager_name'
                            id='plan_manager_name'
                            className='did-floating-input'
                            placeholder='Enter Plan Manager name'
                            {...register("planManagerName")}
                          />
                        </div>
                        <div>
                          <label className='mb-1 block text-sm font-medium text-gray-700'>
                            Plan Manager Email
                          </label>
                          <input
                            type='email'
                            className='did-floating-input'
                            placeholder='Enter Plan Manager email'
                            {...register("planManagerEmail", {
                              pattern: {
                                value: EMAIL_REGEX_EXP,
                                message: "Invalid email address",
                              },
                            })}
                          />
                          {errors.planManagerEmail && (
                            <span className='text-red-500'>
                              {errors.planManagerEmail.message}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className='mb-1 block text-sm font-medium text-gray-700'>
                            Plan Management Company
                          </label>
                          <input
                            type='text'
                            className='did-floating-input'
                            placeholder='Enter company'
                            {...register("planManagerCompany")}
                          />
                        </div>
                      </>
                    )}
                    <div>
                      <label
                        htmlFor=''
                        className='block text-sm font-medium text-gray-700'
                      >
                        Service Start Date
                      </label>
                      <div className='mt-1'>
                        <Controller
                          name='planStartDate'
                          control={control}
                          rules={{
                            required: false,
                            validate: validateStartDate,
                          }}
                          render={({ field }) => (
                            <DateRangeWithRegister
                              isSingleDate
                              field={field}
                              isClearable
                              placeholder='DD/MM/YYYY'
                              //  minDate={new Date()}
                            />
                          )}
                        />
                        {/* <input
                          min={moment().format("DD-MM-YYYY")}
                          type='date'
                          name=''
                          id=''
                          className='did-floating-input'
                          {...register("planStartDate", {
                            required: false,
                            validate: (value) =>
                              value
                                ? Date.parse(value) <
                                  Date.parse(watchAllFields.planEndDate)
                                : undefined,
                          })}
                        /> */}
                        {errors?.planStartDate?.type === "required" && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                        {errors.planStartDate?.type === "validate" && (
                          <span className='text-red-500'>
                            Start Date should be less than End Date
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor=''
                        className='block text-sm font-medium text-gray-700'
                      >
                        Service End Date
                      </label>
                      <div className='mt-1'>
                        <Controller
                          name='planEndDate'
                          control={control}
                          rules={{ required: false, validate: validateEndDate }}
                          render={({ field }) => (
                            <DateRangeWithRegister
                              isSingleDate
                              field={field}
                              isClearable
                              placeholder='DD/MM/YYYY'
                            />
                          )}
                        />
                        {/* <input
                          min={moment().format("DD-MM-YYYY")}
                          type='date'
                          name=''
                          id=''
                          className='did-floating-input'
                          {...register("planEndDate", {
                            required: false,
                          })}
                        /> */}
                        {/* {errors.planEndDate && (
                          <span className='text-red-500'>
                            This field is required &nbsp;
                          </span>
                        )} */}
                        {errors?.planEndDate?.type === "validate" && (
                          <span className='text-red-500'>
                            End date should be greater than start date
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor='public_guardian'
                        className='block text-sm font-medium text-gray-700'
                      >
                        Public Guardian
                      </label>
                      <div className='mt-1'>
                        <input
                          type='text'
                          name='public_guardian'
                          id='public_guardian'
                          className='did-floating-input'
                          {...register("public_guardian", {
                            maxLength: 190,
                          })}
                        />
                        {errors.public_guardian && (
                          <span className='text-red-500'>
                            Character should not exceed 190 characters.
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor='child_safety_officer'
                        className='block text-sm font-medium text-gray-700'
                      >
                        Child Safety Officer
                      </label>
                      <div className='mt-1'>
                        <input
                          type='text'
                          name='child_safety_officer'
                          id='child_safety_officer'
                          className='did-floating-input'
                          {...register("child_safety_officer", {
                            maxLength: 190,
                          })}
                        />
                        {errors.child_safety_officer && (
                          <span className='text-red-500'>
                            Character should not exceed 190 characters.
                          </span>
                        )}
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor='plan_nominee'
                        className='block text-sm font-medium text-gray-700'
                      >
                        Plan Nominee
                      </label>
                      <div className='mt-1'>
                        <input
                          type='text'
                          name='plan_nominee'
                          id='plan_nominee'
                          className='did-floating-input'
                          {...register("plan_nominee", {
                            maxLength: 190,
                          })}
                        />
                        {errors.plan_nominee && (
                          <span className='text-red-500'>
                            Character should not exceed 190 characters.
                          </span>
                        )}
                      </div>
                    </div>
                    {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
                      <div>
                        <label className='mb-1 block text-sm font-medium text-gray-700'>
                          Assigned Workers
                        </label>
                        <SelectOption
                          isMulti={true}
                          data={
                            assignedWorkers && assignedWorkers.length > 0
                              ? workers.filter((x) =>
                                  assignedWorkers.find(
                                    (y) => y.value !== x.value
                                  )
                                )
                              : workers
                          }
                          selectedOption={assignedWorkers}
                          handleChange={(data) => {
                            const diffArray = getDifferenceArray(
                              assignedWorkers,
                              data
                            );
                            setAssignedSupportCoordinators(
                              getDifferenceArray(
                                assignedSupportCoordinators,
                                diffArray
                              )
                            );
                            setAssignedAlliedHealther(
                              getDifferenceArray(
                                assignedAlliedHealther,
                                diffArray
                              )
                            );
                            setAssignedWorkers(data);
                          }}
                        />
                      </div>
                    )}

                    {/* <div>
                      <div className='hidden'>
                        <select
                          {...register("plan", {
                            value: false,
                            // required: true,
                          })}
                          name='plan'
                          id=''
                          className='hidden did-floating-input'
                          defaultValue={false}
                        />
                      </div>
                      <label className='mb-1 block text-sm font-medium text-gray-700'>
                        Plan Managed By
                      </label>
                      <SelectOption
                        isSearch={false}
                        isMulti={false}
                        data={planManagedByOptions}
                        selectedOption={planBy}
                        handleChange={setPlanBy}
                      />
                      {errors.plan && (
                        <span className='text-red-500'>
                          This field is required
                        </span>
                      )}
                    </div> */}

                    <div className='col-span-1 sm:col-span-1'>
                      <label className='block text-sm font-medium text-gray-700'>
                        Region
                      </label>
                      <MultiLevelDropdown
                        regions={regionList || []}
                        setSelectedItem={setSelectedItems}
                        selectedItems={selectedItems}
                        parentRegionLoader={loader}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor=''
                        className='block text-sm font-medium text-gray-700'
                      >
                        Select {participantLabel} Conditions
                      </label>
                      <SelectOption
                        name='labels'
                        id='labels'
                        isMulti={true}
                        data={labels.map((label) => ({
                          label: label.label,
                          value: label.id,
                        }))}
                        selectedOption={ParticipantConditions}
                        handleChange={(selected) => {
                          setParticipantConditions(selected);
                          setValue(
                            "labels",
                            selected.map((item) => item.value)
                          );
                        }}
                        onMenuOpen={fetchLabels} // Fetch labels when the dropdown is opened
                      />

                      {errors.labels && (
                        <span className='text-red-500'>
                          This field is required
                        </span>
                      )}
                    </div>
                    {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
                      <div className='col-span-1 sm:col-span-1'>
                        <label
                          htmlFor='participanttype'
                          className='block text-sm font-medium text-gray-700'
                        >
                          Service Support
                        </label>

                        <SelectOption
                          isMulti={true}
                          data={spDefaultserviceTypes.map((item) => ({
                            value: item.id,
                            label: item.name,
                            funding_type: item.funding_type,
                          }))}
                          selectedOption={participantType}
                          handleChange={setParticipantType}
                        />
                        {errors?.participanttype?.type === "required" && (
                          <div className='text-sm text-red-500'>
                            This field is required!
                          </div>
                        )}
                      </div>
                    )}
                    <div className='col-span-1 sm:col-span-1'>
                      <label className='mb-1 block text-sm font-medium text-gray-700'>
                        {participantLabel} Compliance{" "}
                        <span className='text-red-500'>*</span>
                      </label>
                      <SelectOption
                        data={complianceProfiles}
                        selectedOption={assignedCompliance}
                        handleChange={(option) => {
                          setAssignedCompliance(option);
                          if (option?.value) {
                            setComplianceError("");
                          }
                        }}
                        placeholder='Select compliance template...'
                      />
                      {complianceError && (
                        <span className='text-sm text-red-500'>
                          {complianceError}
                        </span>
                      )}
                      <p className='text-xs text-gray-500 mt-1'>
                        Documents and forms for this {participantLabel.toLowerCase()}&apos;s onboarding compliance score.
                      </p>
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor='comment'
                      className='block text-sm font-medium text-gray-700'
                    >
                      Important Alert{" "}
                      {/* <span className='text-red-500'>* </span> */}
                      <label className='text-gray-500 text-xs font-normal mb-0'>
                        (max. 256)
                      </label>
                    </label>

                    <div className='mt-1'>
                      <textarea
                        rows={1}
                        name='important_alert'
                        id='important_alert'
                        className='mb-0 w-full text-gray-900 border border-gray-300 font-normal text-base rounded-md'
                        {...register("important_alert", {
                          //  required: true
                        })}
                      />
                      {errors.important_alert && (
                        <span className='text-red-500'>Limit exceeded.</span>
                      )}
                      {/* <span className="text-gray-500 text-sm">275 characters left</span> */}
                    </div>
                  </div>

                  <div>
                    <label className='block text-sm font-medium text-gray-700'>
                      Shift Instructions (Please specify default instructions
                      template for your support workers to follow)
                    </label>
                    <textarea
                      rows={3}
                      type='text'
                      className='mb-0 w-full text-gray-900 border border-gray-300 font-normal text-base rounded-md'
                      setValue={setValue}
                      {...register("shift_instruction", { required: false })}
                      value={watchFormData?.shift_instruction}
                      name='shift_instruction'
                      defaultValue={""}
                    />
                  </div>

                  <ParticipantShiftTasksNotes
                    ref={shiftTasksNotesRef}
                    settingTasks={resolvedSettingTasks}
                    isUserGracePeriodOver={isUserGracePeriodOver}
                    canEdit={roleAccess([
                      USER_ROLE.Sp_Admin,
                      USER_ROLE.Sp_manager,
                    ])}
                  />

                  <div className='border border-gray-200 py-7 px-6 rounded-lg mt-2'>
                    <div className='mb-4'>
                      <label className='text-gray-700 text-lg font-bold'>
                        Default Shift End Questions
                      </label>

{roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
                      <p className='text-sm text-gray-600 mt-1'>
                        Select up to 8 questions for {participantLabel.toLowerCase()}{" "}
                        shift end screen (Selected: {selectedQuestions.length}/8)
                      </p>
                    )}
                    </div>

                    {isLoadingQuestions ? (
                      <div className='flex justify-center items-center h-32'>
                        <Loader isSmallView={true} cssClass={"text-black"} />
                      </div>
                    ) : (
                      <>

  {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
 <div className='space-y-8 pr-4  max-h-96 overflow-y-auto scrollbar-thin'
          style={{
            scrollbarColor: '#38528A transparent',
            scrollbarWidth: 'thin',
          }}>
                          {questions.length === 0 ? (
                            <p className='text-gray-500 text-center py-4'>
                              No questions available
                            </p>
                          ) : (
                            questions.map((question) => (
                              <div
                                key={question.id}
                                className={`p-3 border rounded-lg cursor-pointer transition-all ${
                                  selectedQuestions.find(
                                    (q) => q.id === question.id
                                  )
                                    ? "border-blue-500 bg-blue-50"
                                    : "border-gray-200 hover:border-gray-300"
                                } ${
                                  selectedQuestions.length >= 8 &&
                                  !selectedQuestions.find(
                                    (q) => q.id === question.id
                                  )
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                onClick={() => handleQuestionToggle(question)}
                              >
                                <div className='flex items-start'>
                                  <div className='flex-shrink-0'>
                                    <input
                                      type='checkbox'
                                      checked={
                                        !!selectedQuestions.find(
                                          (q) => q.id === question.id
                                        )
                                      }
                                      onChange={() =>
                                        handleQuestionToggle(question)
                                      }
                                      disabled={
                                        selectedQuestions.length >= 8 &&
                                        !selectedQuestions.find(
                                          (q) => q.id === question.id
                                        )
                                      }
                                      className='mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded'
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </div>
                                  <div className='ml-3 flex-1'>
                                    <p className='text-sm font-medium text-gray-900'>
                                      {question.question}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
  )}



{roleAccess([USER_ROLE.Sp_Standard_User]) && (
  <div className='space-y-8 pr-4 max-h-96 overflow-y-auto scrollbar-thin'
    style={{
      scrollbarColor: '#38528A transparent',
      scrollbarWidth: 'thin',
    }}>
    {questions.length === 0 ? (
      <p className='text-gray-500 text-center py-4'>
        No questions available
      </p>
    ) : (
      questions.map((question) => (
        <div
          key={question.id}
          className={`p-3 border rounded-lg transition-all border-gray-200 bg-gray-50`}
        >
          <div className='flex items-start'>
            <div className='flex-shrink-0'>
              <input
                type='checkbox'
                checked={!!selectedQuestions.find((q) => q.id === question.id)}
                disabled
                className='mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded cursor-not-allowed'
                tabIndex={-1}
              />
            </div>
            <div className='ml-3 flex-1'>
              <p className='text-sm font-medium text-gray-900'>
                {question.question}
              </p>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
)}


                        {selectedQuestions.length > 0 && (
                          <div className='mt-4 p-3 bg-gray-50 rounded-lg'>
                            <p className='text-sm font-medium text-gray-700 mb-2'>
                              Selected Questions ({selectedQuestions.length}):
                            </p>
                            <div className='space-y-2'>
                              {selectedQuestions.map((question, index) => (
                                <div
                                  key={question.id}
                                  className='flex items-center text-sm'
                                >
                                  <span className='w-6 h-6 flex items-center justify-center bg-blue-500 text-white rounded-full text-xs mr-2'>
                                    {index + 1}
                                  </span>
                                  <span className='flex-1 text-gray-700'>
                                    {question.question}
                                  </span>
                                  <div className='ml-3 flex-shrink-0'>
                                    {renderMandatoryToggle(question)}
                                  </div>
                                  <button
                                    type='button'
                                    onClick={() =>
                                      handleQuestionRemove(question.id)
                                    }
                                    className='ml-2 text-red-500 hover:text-red-700 p-1'
                                    title='Remove question'
                                  >
                                    <svg
                                      className='w-4 h-4'
                                      fill='currentColor'
                                      viewBox='0 0 20 20'
                                    >
                                      <path
                                        fillRule='evenodd'
                                        d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                                        clipRule='evenodd'
                                      />
                                    </svg>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {/* for external coordinator fields*/}
                  <div className='border border-gray-200 py-7 px-6 rounded-lg mt-2'>
                    <div>
                      <label className='text-gray-700 text-lg font-bold '>
                        External Coordinator
                      </label>
                    </div>
                    <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
                      <div>
                        <label className='block mb-1 text-sm font-medium text-gray-700'>
                          External Coordinator Name{" "}
                        </label>
                        <input
                          type='text'
                          maxLength={255}
                          className='did-floating-input'
                          placeholder='Enter Coordinator Name'
                          {...register("externalCoordinatorName", {
                            maxLength: {
                              value: 255,
                              message: "Maximum 255 characters allowed."
                            }
                          })}
                        />
                        <div className="flex items-center justify-between mt-1">
                          {errors?.externalCoordinatorName?.type === "maxLength" && (
                            <span className="text-red-500 text-sm">
                              {errors.externalCoordinatorName.message}
                            </span>
                          )}
                          <span className={`text-xs ml-auto ${(externalCoordinatorName?.length || 0) >= 255 ? 'text-red-500' : (externalCoordinatorName?.length || 0) >= 230 ? 'text-orange-500' : 'text-gray-500'}`}>
                            {(externalCoordinatorName?.length || 0)} / 255
                          </span>
                        </div>
                      </div>

                      <div>
                        <label className='mb-1 block text-sm font-medium text-gray-700'>
                          External Coordinator Email{" "}
                        </label>
                        <input
                          type='text'
                          className='did-floating-input'
                          placeholder='Enter Coordinator Email'
                          {...register("externalCoordinatorEmail")}
                        />
                      </div>

                      <div>
                        <label className='block mb-1 text-sm font-medium text-gray-700'>
                          External Coordinator Company
                        </label>
                        <input
                          type='text'
                          maxLength={255}
                          className='did-floating-input'
                          placeholder='Enter Coordinator Company'
                          {...register("externalCoordinatorCompany", {
                            maxLength: {
                              value: 255,
                              message: "Maximum 255 characters allowed."
                            }
                          })}
                        />
                        <div className="flex items-center justify-between mt-1">
                          {errors?.externalCoordinatorCompany?.type === "maxLength" && (
                            <span className="text-red-500 text-sm">
                              {errors.externalCoordinatorCompany.message}
                            </span>
                          )}
                          <span className={`text-xs ml-auto ${(externalCoordinatorCompany?.length || 0) >= 255 ? 'text-red-500' : (externalCoordinatorCompany?.length || 0) >= 230 ? 'text-orange-500' : 'text-gray-500'}`}>
                            {(externalCoordinatorCompany?.length || 0)} / 255
                          </span>
                        </div>
                      </div>

                      <div>
                        <label className='block mb-1 text-sm font-medium text-gray-700'>
                          External Coordinator Phone
                        </label>
                        <input
                          type='text'
                          maxLength={10}
                          className='did-floating-input'
                          placeholder='Enter Coordinator Phone'
                          {...register("externalCoordinatorPhone", {
                            maxLength: 10,
                            pattern: REGEX_PHONE_NUMBER,
                            onChange: (e) => {
                              const sanitizedValue = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              const formattedValue = sanitizedValue.slice(
                                0,
                                10
                              );
                              e.target.value = formattedValue;
                            },
                          })}
                        />
                        {errors?.externalCoordinatorPhone?.type === "maxLength" && (
                          <span className="text-red-500 text-sm">
                            Phone number must be exactly 10 digits
                          </span>
                        )}
                        {errors?.externalCoordinatorPhone?.type === "pattern" && (
                          <span className="text-red-500 text-sm">
                            Phone number must contain only digits
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='border border-gray-200 py-7 px-6 rounded-lg mt-2'>
                    <div>
                      <label className='text-gray-700 text-lg font-bold '>
                        Pricing
                      </label>
                    </div>
                    <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
                      <div>
                        <div className='hidden'>
                          <select
                            {...register("state_id", {
                              //value: false,
                              //required: true,
                            })}
                            name='state_id'
                            id=''
                            className='hidden did-floating-input'
                            defaultValue={false}
                          />
                        </div>
                        <label className='block mb-1 text-sm font-medium text-gray-700'>
                          Service Catalogue State{" "}
                          {/* <span className='text-red-600'>*</span> */}
                        </label>
                        <SelectOption
                          isSearch={false}
                          data={catalogStates}
                          selectedOption={catalogState}
                          handleChange={setCatalogState}
                          useMenuPortal={true}
                        />
                        {/* {errors.state_id && (
                          <span className=' text-sm text-red-500'>
                            This field is required
                          </span>
                        )} */}
                      </div>

                      <div>
                        <div className='hidden'>
                          <select
                            {...register("roster_invoicing_item", {
                              //required: true,
                            })}
                            name='roster_invoicing_item'
                            id=''
                            className='hidden did-floating-input'
                          />
                        </div>
                        <label className='mb-1 block text-sm font-medium text-gray-700'>
                          Category Item Name
                        </label>
                        <SelectOption
                          // isMulti={true}
                          isSearch={false}
                          data={CATEGORY_ITEM_NAME_AND_NOTES}
                          selectedOption={rosterInvoicing}
                          handleChange={setRosterInvoicing}
                        />
                        {/* {!rosterInvoicing &&
                          errors?.roster_invoicing_item?.type ===
                            "required" && (
                            <span className='text-red-500'>
                              This field is required
                            </span>
                          )} */}
                      </div>

                      <div>
                        <div className='hidden'>
                          <select
                            {...register("invoice_category_id", {
                              //value: false,
                              //required: true,
                            })}
                            name='invoice_category_id'
                            id=''
                            className='hidden did-floating-input'
                            defaultValue={false}
                          />
                        </div>
                        <label className='block mb-1 text-sm font-medium text-gray-700'>
                          Service Category
                          {/* <span className='text-red-600'>*</span> */}
                        </label>
                        <SelectOption
                          isDisabled={isFetchServiceCatLoader}
                          loading={isFetchServiceCatLoader}
                          isSearch={true}
                          data={filteredServiceTypes}
                          selectedOption={
                            filteredServiceTypesFlat?.find(
                              (o) => o.id === watchFormData?.invoice_category_id
                            ) || null
                          }
                          handleChange={(e) =>
                            setValue("invoice_category_id", e.value)
                          }
                        />
                        {/* {errors.invoice_category_id && (
                          <span className=' text-sm text-red-500'>
                            This field is required
                          </span>
                        )} */}
                      </div>

                      <div className='col-span-2'>
                        <label className='text-gray-700 text-sm font-medium mb-1'>
                          Emails for Invoice (Enter one email, press "Enter" to
                          add another. repeat for more emails.)
                        </label>

                        <div className='mb-2'>
                          <ReactMultiEmail
                            placeholder='Input your emails'
                            emails={emails}
                            onChange={(_emails) => {
                              setEmails(_emails);
                            }}
                            autoFocus={false}
                            onFocus={() => setFocused(true)}
                            onBlur={() => setFocused(false)}
                            getLabel={(email, index, removeEmail) => {
                              return (
                                <div data-tag key={index}>
                                  <div data-tag-item>{email}</div>
                                  <span
                                    data-tag-handle
                                    onClick={() => removeEmail(index)}
                                  >
                                    ×
                                  </span>
                                </div>
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* For Xero */}
                  {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) &&
                    (isCheckPayrollAuthLoading ? (
                      <Loader isSmallView={true} cssClass={"text-black"} />
                    ) : (
                      <div className='border border-gray-200 py-7 px-6 rounded-lg mt-2'>
                        <div>
                          <label className='pb-2 text-gray-700 text-lg font-bold '>
                            Payroll
                          </label>
                        </div>
                        <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
                          <div className='col-span-2'>
                            <label className='text-gray-700 text-sm font-medium mb-1'>
                              Xero Contact ID
                            </label>
                            {isAuthenticateForPayrolls !== null &&
                            parseBooleanVal(
                              isAuthenticateForPayrolls[PAYROLL_PLATFORMS.XERO]
                            ) ? (
                              <div className='w-full flex space-x-2'>
                                <div className='w-[95%]'>
                                  <input
                                    type='text'
                                    name='name'
                                    id='name'
                                    className='did-floating-input'
                                    {...register("xero_contact_id", {
                                      // required: true,
                                      maxLength: 254,
                                    })}
                                  />
                                  {errors.xero_contact_id && (
                                    <span className='text-red-500'>
                                      This field is required
                                    </span>
                                  )}
                                </div>

                                <div className='w-[5%] flex justify-center items-center'>
                                  <span
                                    onClick={() => setXeroImage(true)}
                                    title='xero employee id'
                                    className='h-6 w-6 flex  cursor-pointer  justify-center items-center rounded-full bg-[#3E5A99] text-white'
                                  >
                                    <AiOutlineQuestion />
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div
                                onClick={() => navigate("/payroll-setting")}
                                className='mt-1 text-sm text-gray-900 flex items-center space-x-2 cursor-pointer'
                              >
                                <span className='text-blue-700'>
                                  Connect Xero
                                </span>
                                <span className='text-blue-600'>
                                  <FiArrowUpRight />
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div className='border border-gray-200 py-5 px-4 rounded-lg'>
                    <div className='mb-4'>
                      <label className='text-gray-700 text-lg font-bold'>
                        Family App Access
                      </label>
                      <p className='mt-1 text-sm text-gray-500'>
                        Who can log in and request shifts for this participant.
                      </p>
                    </div>
                    {!familyAppLoginAllowed ? (
                      <div className='mb-4'>
                        <PlanUpgradeGate
                          feature='family_app_access'
                          title='App login not available on your plan'
                          message={getFamilyAppLoginUpgradeMessage()}
                          user={planFeatureUser}
                          compact
                        />
                      </div>
                    ) : null}
                    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 items-start'>
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT.PRIMARY_EMAIL
                    ) && (
                      <div className='rounded-lg border border-gray-200 bg-gray-50 p-4 space-y-4'>
                        <div>
                          <p className='text-sm font-semibold text-gray-900'>
                            Participant
                          </p>
                          <p className='mt-0.5 text-xs text-gray-500'>
                            The participant logs in with this email.
                          </p>
                        </div>
                        <div className='flex flex-wrap items-center gap-2'>
                          <p className='text-sm text-gray-900 break-all'>
                            {(primaryEmailWatched || "").trim() || "—"}
                          </p>
                          {showParticipantAppInviteStatus &&
                          (participantAppInviteStatus === "active" ||
                            participantAppInviteStatus === "pending") ? (
                            <>
                              <span
                                className={`shrink-0 rounded-md px-2 py-0.5 text-xs font-medium ${
                                  participantAppInviteStatus === "active"
                                    ? "bg-emerald-50 text-emerald-700"
                                    : "bg-amber-50 text-amber-800"
                                }`}
                              >
                                {participantAppInviteStatus === "active"
                                  ? "Active"
                                  : "Pending"}
                              </span>
                              {participantAppInviteStatus === "pending" &&
                              participantAppCanResendInvite ? (
                                <button
                                  type='button'
                                  disabled={Boolean(familyEmailBusyKey)}
                                  className={`shrink-0 text-sm transition-colors duration-150 ${
                                    familyEmailBusyKey
                                      ? "cursor-not-allowed text-gray-300"
                                      : "cursor-pointer text-indigo-600 hover:text-indigo-800"
                                  }`}
                                  onClick={() =>
                                    resendFamilyAppInvite({
                                      busyKey: "participant-resend",
                                    })
                                  }
                                >
                                  {familyEmailBusyKey === "participant-resend"
                                    ? "Sending…"
                                    : "Resend email"}
                                </button>
                              ) : null}
                            </>
                          ) : null}
                        </div>
                        <div className='rounded-lg border border-gray-200 bg-white divide-y divide-gray-200 [&_p+span]:block [&_p+span]:text-xs [&_p+span]:leading-snug [&_p+span]:text-gray-500'>
                          <div className='px-3 py-2.5'>
                            <SwitchInput
                              cssClass='rounded-lg items-start gap-2'
                              handleChange={(checked) => {
                                if (checked && !participantLoginAllowed) {
                                  toast.error(
                                    getFamilyAppLoginUpgradeMessage()
                                  );
                                  return;
                                }
                                setParticipantAppEnabled(checked);
                                if (!checked) {
                                  setPtShiftReqAllow(false);
                                  clearErrors("primary_email");
                                  participantEmailValidateSeq.current += 1;
                                  participantEmailValidateSig.current = "";
                                  setParticipantEmailStatus({
                                    userExist: false,
                                    validationMessage: "",
                                    successMessage: "",
                                    validating: false,
                                  });
                                }
                              }}
                              checked={
                                participantAppEnabled &&
                                participantLoginAllowed
                              }
                              isDisabled={!participantLoginAllowed}
                              label='Participant App Access'
                              subLabel='Lets this email open the participant app.'
                            />
                          </div>
                          <div
                            className={`px-3 py-2.5 transition-opacity duration-150 ease-in-out ${
                              participantAppEnabled && participantLoginAllowed
                                ? ""
                                : "opacity-50"
                            }`}
                          >
                            <SwitchInput
                              cssClass='rounded-lg items-start gap-2'
                              isDisabled={
                                !participantAppEnabled ||
                                !participantLoginAllowed
                              }
                              handleChange={setPtShiftReqAllow}
                              checked={
                                participantAppEnabled &&
                                participantLoginAllowed &&
                                ptShiftReqAllow
                              }
                              label='Allow Shift Requests'
                              subLabel='Participant can submit shift requests for approval.'
                            />
                          </div>
                          {participantLoginAllowed && !participantAppEnabled ? (
                            <p className='px-3 py-2 text-xs leading-snug text-gray-500'>
                              Turn on Participant App Access to allow shift
                              requests.
                            </p>
                          ) : null}
                        </div>
                      </div>
                    )}
                    <div
                      className={`rounded-lg border border-gray-200 bg-gray-50 p-4 space-y-4 ${
                        roleAccess(
                          [],
                          PERMISSION_KEYS.PARTICIPANT,
                          PERMISSION_KEYS_CHILDREN.PARTICIPANT.PRIMARY_EMAIL
                        )
                          ? ""
                          : "lg:col-span-2"
                      }`}
                    >
                    <div>
                      <p className='text-sm font-semibold text-gray-900'>
                        Family
                      </p>
                      <p className='mt-0.5 text-xs text-gray-500'>
                        Family members log in to view the schedule. Up to 5
                        emails.
                      </p>
                    </div>
                    <div className='rounded-lg border border-gray-200 bg-white divide-y divide-gray-200 [&_p+span]:block [&_p+span]:text-xs [&_p+span]:leading-snug [&_p+span]:text-gray-500'>
                      <div className='px-3 py-2.5'>
                      <SwitchInput
                        cssClass='rounded-lg items-start gap-2'
                        handleChange={(checked) => {
                          if (checked && !familyLoginAllowed) {
                            toast.error(getFamilyAppLoginUpgradeMessage());
                            return;
                          }
                          setFamilyAppEnabled(checked);
                          if (!checked) {
                            setAllowShiftRequests(false);
                            return;
                          }
                          setFamilyEmails((prev) =>
                            prev.length === 0
                              ? [createFamilyEmailEntry()]
                              : prev
                          );
                        }}
                        checked={
                          familyAppEnabled && familyLoginAllowed
                        }
                        isDisabled={!familyLoginAllowed}
                        label='Family App'
                        subLabel="Lets family members view this participant's schedule."
                      />
                      </div>
                      <div
                        className={`px-3 py-2.5 transition-opacity duration-150 ease-in-out ${
                          familyAppEnabled && familyLoginAllowed
                            ? ""
                            : "opacity-50"
                        }`}
                      >
                      <SwitchInput
                        cssClass='rounded-lg items-start gap-2'
                        isDisabled={!familyAppEnabled || !familyLoginAllowed}
                        handleChange={setAllowShiftRequests}
                        checked={
                          familyAppEnabled &&
                          familyLoginAllowed &&
                          allowShiftRequests
                        }
                        label='Allow Shift Requests'
                        subLabel='Family members can submit shift requests for approval.'
                      />
                      </div>
                      {familyLoginAllowed && !familyAppEnabled ? (
                        <p className='px-3 py-2 text-xs leading-snug text-gray-500'>
                          Turn on Family App to restore schedule access and shift
                          requests.
                        </p>
                      ) : null}
                    </div>
                    {familyLoginAllowed ? (
                    <div
                      className={`mt-4 grid transition-[grid-template-rows] duration-200 ease-in-out ${
                        familyAppEnabled
                          ? "grid-rows-[1fr]"
                          : "grid-rows-[0fr]"
                      }`}
                      aria-hidden={!familyAppEnabled}
                    >
                    <div
                      className={`overflow-hidden min-h-0 ${
                        familyAppEnabled ? "" : "pointer-events-none"
                      }`}
                    >
                        <div>
                          <div className='flex flex-wrap items-baseline gap-x-2 gap-y-1'>
                            <label className='text-sm font-medium text-gray-700'>
                              Family Member Emails{" "}
                              <span className='text-red-500'>*</span>
                            </label>
                            <span className='text-sm text-gray-500'>
                              (
                              {
                                familyEmails.filter((row) =>
                                  Boolean((row.email || "").trim())
                                ).length
                              }
                              /{MAX_FAMILY_MEMBER_EMAILS} added)
                            </span>
                          </div>
                          <p className='mt-1 text-sm text-gray-500'>
                            Add emails with ✓.{" "}
                            <span className='font-medium text-gray-600'>
                              Save Changes
                            </span>{" "}
                            sends an invite so they can set their password.
                          </p>
                          <div className='mt-3 rounded-lg border border-gray-200 bg-white p-3'>
                          <div className='space-y-3'>
                              {familyEmails.map((row, index) => {
                                const status = familyEmailStatus[row.key] || {};
                                const showReadOnly =
                                  Boolean(row.baselineEmail) && !row.editMode;
                                const hasContent = Boolean(
                                  (row.email || "").trim()
                                );
                                const isActiveOnServer = (
                                  baselineFamilyEmails || []
                                ).some(
                                  (email) =>
                                    email.trim().toLowerCase() ===
                                    (row.baselineEmail || "")
                                      .trim()
                                      .toLowerCase()
                                );
                                const isPasswordActive =
                                  row.inviteStatus === "active";
                                const canResendInvite =
                                  !isPasswordActive &&
                                  row.canResendInvite === true;
                                const isEditingActive =
                                  Boolean(row.baselineEmail) &&
                                  row.editMode &&
                                  isActiveOnServer;
                                const canConfirm =
                                  !showReadOnly &&
                                  hasContent &&
                                  Boolean(status.successMessage) &&
                                  !status.validating &&
                                  !status.validationMessage;

                                const applyLinkedEmails = (linked) => {
                                  if (!Array.isArray(linked)) return;
                                  const { uniqueEmails, rows } =
                                    buildFamilyEmailRowsFromList(linked);
                                  setBaselineFamilyEmails(uniqueEmails);
                                  setFamilyEmails(rows);
                                  setFamilyEmailStatus({});
                                };

                                const dropEmailRowLocally = () => {
                                  setFamilyEmails((prev) => {
                                    const next = prev.filter(
                                      (item) => item.key !== row.key
                                    );
                                    return next.length > 0
                                      ? next
                                      : [createFamilyEmailEntry()];
                                  });
                                  setFamilyEmailStatus((prev) => {
                                    const next = { ...prev };
                                    delete next[row.key];
                                    return next;
                                  });
                                  delete familyEmailRowValidateSig.current[
                                    row.key
                                  ];
                                };

                                const clearDraftEmail = () => {
                                  // Editing Active — ✕ cancels back to Active
                                  if (isEditingActive) {
                                    familyEmailValidateSeqByKey.current[
                                      row.key
                                    ] =
                                      (familyEmailValidateSeqByKey.current[
                                        row.key
                                      ] || 0) + 1;
                                    familyEmailRowValidateSig.current[
                                      row.key
                                    ] = `${row.baselineEmail}|0|${row.baselineEmail}`;
                                    setFamilyEmails((prev) =>
                                      prev.map((item) =>
                                        item.key === row.key
                                          ? {
                                              ...item,
                                              email: item.baselineEmail,
                                              editMode: false,
                                            }
                                          : item
                                      )
                                    );
                                    setFamilyEmailStatus((prev) => {
                                      const next = { ...prev };
                                      delete next[row.key];
                                      return next;
                                    });
                                    return;
                                  }

                                  familyEmailValidateSeqByKey.current[row.key] =
                                    (familyEmailValidateSeqByKey.current[
                                      row.key
                                    ] || 0) + 1;
                                  familyEmailRowValidateSig.current[row.key] =
                                    "|1|";
                                  setFamilyEmails((prev) =>
                                    prev.map((item) =>
                                      item.key === row.key
                                        ? {
                                            ...item,
                                            email: "",
                                            baselineEmail: "",
                                            editMode: true,
                                          }
                                        : item
                                    )
                                  );
                                  setFamilyEmailStatus((prev) => {
                                    const next = { ...prev };
                                    delete next[row.key];
                                    return next;
                                  });
                                };

                                const removeEmailRow = async () => {
                                  if (familyEmailBusyKey) return;

                                  // Active (already on server): confirm → soft-unlink now
                                  if (isActiveOnServer && showReadOnly) {
                                    setFamilyMemberConfirm({
                                      mode: "remove",
                                      rowKey: row.key,
                                      email: (row.email || "").trim(),
                                    });
                                    return;
                                  }

                                  // Invite (not saved yet) — drop from local list only
                                  dropEmailRowLocally();
                                };

                                const confirmEmailRow = async () => {
                                  const email = (row.email || "").trim();
                                  if (!email || !canConfirm) return;

                                  // Active update — confirm → API now
                                  if (isEditingActive) {
                                    const oldEmail = (
                                      row.baselineEmail || ""
                                    ).trim();
                                    if (
                                      email.toLowerCase() ===
                                      oldEmail.toLowerCase()
                                    ) {
                                      clearDraftEmail();
                                      return;
                                    }

                                    setFamilyMemberConfirm({
                                      mode: "update",
                                      rowKey: row.key,
                                      oldEmail,
                                      newEmail: email,
                                    });
                                    return;
                                  }

                                  familyEmailValidateSeqByKey.current[row.key] =
                                    (familyEmailValidateSeqByKey.current[
                                      row.key
                                    ] || 0) + 1;
                                  familyEmailRowValidateSig.current[
                                    row.key
                                  ] = `${email}|0|${email}`;

                                  setFamilyEmails((prev) => {
                                    const updated = prev.map((item) =>
                                      item.key === row.key
                                        ? {
                                            ...item,
                                            email,
                                            baselineEmail: email,
                                            editMode: false,
                                            userExist:
                                              status.userExist === true,
                                          }
                                        : item
                                    );
                                    const hasOpenDraft = updated.some(
                                      (item) => !item.baselineEmail
                                    );
                                    if (
                                      !hasOpenDraft &&
                                      updated.length < MAX_FAMILY_MEMBER_EMAILS
                                    ) {
                                      return [
                                        ...updated,
                                        createFamilyEmailEntry(),
                                      ];
                                    }
                                    return updated;
                                  });
                                  setFamilyEmailStatus((prev) => {
                                    const next = { ...prev };
                                    delete next[row.key];
                                    return next;
                                  });
                                };

                                return (
                                  <div key={row.key}>
                                    <div className='flex flex-wrap items-center gap-2'>
                                      {showReadOnly ? (
                                        <>
                                          <div className='flex min-w-0 flex-1 items-center gap-3 rounded-md bg-white px-3 py-2 shadow-sm ring-1 ring-gray-100'>
                                            <span
                                              className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold uppercase text-slate-700'
                                              aria-hidden
                                            >
                                              {(row.email || "?")
                                                .trim()
                                                .charAt(0)
                                                .toUpperCase() || "?"}
                                            </span>
                                            <span className='min-w-0 flex-1 break-all text-sm font-medium text-gray-900'>
                                              {row.email}
                                            </span>
                                            <span
                                              className={`shrink-0 rounded-md px-2 py-0.5 text-xs font-medium ${
                                                isPasswordActive
                                                  ? "bg-emerald-50 text-emerald-700"
                                                  : "bg-amber-50 text-amber-800"
                                              }`}
                                            >
                                              {isPasswordActive
                                                ? "Active"
                                                : "Pending"}
                                            </span>
                                          </div>
                                          {canResendInvite &&
                                          isActiveOnServer ? (
                                            <button
                                              type='button'
                                              disabled={Boolean(
                                                familyEmailBusyKey
                                              )}
                                              className={`shrink-0 text-sm transition-colors duration-150 ${
                                                familyEmailBusyKey
                                                  ? "cursor-not-allowed text-gray-300"
                                                  : "cursor-pointer text-indigo-600 hover:text-indigo-800"
                                                  }`}
                                              onClick={() =>
                                                resendFamilyAppInvite({
                                                  email: (row.email || "").trim(),
                                                  busyKey: row.key,
                                                })
                                              }
                                            >
                                              {familyEmailBusyKey === row.key
                                                ? "Sending…"
                                                : "Resend email"}
                                            </button>
                                          ) : null}
                                          {isActiveOnServer ? (
                                            <button
                                              type='button'
                                              className='shrink-0 text-sm text-gray-500 transition-colors duration-150 hover:text-gray-800 cursor-pointer'
                                              onClick={() => {
                                                setFamilyEmails((prev) =>
                                                  prev.map((item) =>
                                                    item.key === row.key
                                                      ? {
                                                          ...item,
                                                          editMode: true,
                                                        }
                                                      : item
                                                  )
                                                );
                                              }}
                                            >
                                              Edit
                                            </button>
                                          ) : null}
                                          <button
                                            type='button'
                                            disabled={!!familyEmailBusyKey}
                                            className={`shrink-0 text-sm transition-colors duration-150 ${
                                              familyEmailBusyKey
                                                ? "cursor-not-allowed text-gray-300"
                                                : "cursor-pointer text-gray-400 hover:text-red-600"
                                            }`}
                                            onClick={removeEmailRow}
                                          >
                                            {familyEmailBusyKey === row.key
                                              ? "Removing…"
                                              : "Remove"}
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          <div className='relative min-w-[12rem] flex-1'>
                                            <input
                                              id={`family-member-email-${row.key}`}
                                              type='text'
                                              inputMode='email'
                                              autoComplete='email'
                                              placeholder='name@example.com'
                                              aria-label={`Family member email ${
                                                index + 1
                                              }`}
                                              aria-busy={status.validating}
                                              aria-invalid={
                                                status.validationMessage
                                                  ? "true"
                                                  : "false"
                                              }
                                              className={`did-floating-input ${
                                                status.validationMessage
                                                  ? "border-red-500"
                                                  : ""
                                              } ${
                                                status.validating ||
                                                canConfirm ||
                                                hasContent
                                                  ? "pr-20"
                                                  : ""
                                              }`}
                                              value={row.email}
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                setFamilyEmails((prev) =>
                                                  prev.map((item) =>
                                                    item.key === row.key
                                                      ? {
                                                          ...item,
                                                          email: value,
                                                        }
                                                      : item
                                                  )
                                                );
                                              }}
                                              onKeyDown={(e) => {
                                                if (
                                                  e.key === "Enter" &&
                                                  canConfirm
                                                ) {
                                                  e.preventDefault();
                                                  confirmEmailRow();
                                                }
                                              }}
                                            />
                                            <div className='absolute right-2 top-1/2 flex -translate-y-1/2 items-center gap-1'>
                                              {status.validating ? (
                                                <span
                                                  className='h-4 w-4 rounded-full border-2 border-slate-200 border-t-blue-600 animate-spin'
                                                  role='status'
                                                  aria-label='Verifying email'
                                                />
                                              ) : null}
                                              {canConfirm ? (
                                                <button
                                                  type='button'
                                                  className='rounded p-1 text-emerald-600 transition-colors hover:bg-emerald-50 cursor-pointer'
                                                  onClick={confirmEmailRow}
                                                  aria-label={
                                                    isEditingActive
                                                      ? "Update email"
                                                      : "Add email to list"
                                                  }
                                                  title={
                                                    isEditingActive
                                                      ? "Update"
                                                      : "Add to list"
                                                  }
                                                >
                                                  <FiCheck className='h-4 w-4' />
                                                </button>
                                              ) : null}
                                              {hasContent ||
                                              isEditingActive ? (
                                                <button
                                                  type='button'
                                                  className='rounded p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700 cursor-pointer'
                                                  onClick={clearDraftEmail}
                                                  aria-label={
                                                    isEditingActive
                                                      ? "Cancel edit"
                                                      : "Clear email"
                                                  }
                                                  title={
                                                    isEditingActive
                                                      ? "Cancel"
                                                      : "Clear"
                                                  }
                                                >
                                                  <FiX className='h-4 w-4' />
                                                </button>
                                              ) : null}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    {!showReadOnly &&
                                    status.validating &&
                                    !status.validationMessage &&
                                    !status.successMessage ? (
                                      <p
                                        className='mt-1 text-sm text-slate-500'
                                        aria-live='polite'
                                      >
                                        Checking email…
                                      </p>
                                    ) : null}
                                    {!showReadOnly &&
                                    status.successMessage &&
                                    !status.validating &&
                                    !status.validationMessage ? (
                                      <p
                                        className={`mt-1 text-sm ${
                                          status.userExist
                                            ? "text-amber-800"
                                            : "text-emerald-800"
                                        }`}
                                        aria-live='polite'
                                      >
                                        {status.successMessage}{" "}
                                        <span className='text-gray-500'>
                                          {isEditingActive
                                            ? "Click ✓ to update now."
                                            : "Click ✓ to add. Save Changes emails the invite link."}
                                        </span>
                                      </p>
                                    ) : null}
                                    {!showReadOnly &&
                                    status.validationMessage ? (
                                      <p
                                        className='mt-1 text-sm text-red-600'
                                        aria-live='polite'
                                      >
                                        {status.validationMessage}
                                      </p>
                                    ) : null}
                                  </div>
                                );
                              })}
                          </div>
                          </div>
                          <p className='mt-2 text-sm text-gray-400'>
                            {familyEmails.filter((row) => row.baselineEmail)
                              .length >= MAX_FAMILY_MEMBER_EMAILS ? (
                              `Maximum of ${MAX_FAMILY_MEMBER_EMAILS} emails reached.`
                            ) : familyEmails.some(
                                (row) => !row.baselineEmail
                              ) ? null : (
                              <button
                                type='button'
                                className='text-sm text-gray-500 underline-offset-2 transition-colors duration-150 hover:text-blue-600 hover:underline cursor-pointer'
                                onClick={() => {
                                  if (
                                    familyEmails.filter(
                                      (row) => row.baselineEmail
                                    ).length >= MAX_FAMILY_MEMBER_EMAILS
                                  ) {
                                    return;
                                  }
                                  setFamilyEmails((prev) => [
                                    ...prev,
                                    createFamilyEmailEntry(),
                                  ]);
                                }}
                              >
                                Add email
                              </button>
                            )}
                          </p>
                        </div>
                    </div>
                    </div>
                    ) : null}
                    </div>
                    </div>
                  </div>
                <div className='px-4 py-5 bg-white space-y-6 sm:p-6 '>
                  {addBlockDiv()}
                  <div className='flex gap-x-4'>
                    <SwitchInput
                      handleChange={setEnabled}
                      checked={enabled}
                      label='Is active'
                      subLabel={`is the ${participantLabel.toLowerCase()} active`}
                    />

                    <SwitchInput
                      handleChange={(checked) => setOptInStatus(checked ? 'opted_in' : 'opted_out')}
                      checked={optInStatus === 'opted_in'}
                      label='Opt-in Audit'
                      subLabel={`Include this ${participantLabel.toLowerCase()} in audit reports and compliance checks`}
                    />

                    <SwitchInput
                      handleChange={setSupportCoordination}
                      checked={supportCoordination}
                      label='Support Coordination'
                      subLabel='Require Support Coordination Services'
                    />

                    <SwitchInput
                      handleChange={setAlliedHealth}
                      checked={alliedHealth}
                      label='Allied Health'
                      subLabel='Require Allied Health Services'
                    />
                  </div>
                  <div className='flex gap-x-4'>
                    {supportCoordination && (
                      <div className='w-1/2'>
                        <div className='hidden'>
                          <select
                            {...register("support_coordinators", {
                              // required: false,
                            })}
                            name='support_coordinators'
                            id=''
                            className='hidden did-floating-input'
                          />
                        </div>
                        <label className='mb-1 block text-sm font-medium text-gray-700'>
                          Assigned Support Coordinators
                        </label>
                        <SelectOption
                          isMulti={true}
                          data={
                            assignedSupportCoordinators &&
                            assignedSupportCoordinators.length > 0
                              ? supportCoordinators.filter((x) =>
                                  assignedSupportCoordinators.find(
                                    (y) => y.value !== x.value
                                  )
                                )
                              : supportCoordinators
                          }
                          selectedOption={assignedSupportCoordinators}
                          handleChange={(data) => {
                            const diffArray = getDifferenceArray(
                              assignedSupportCoordinators,
                              data
                            );
                            setAssignedWorkers(
                              getDifferenceArray(assignedWorkers, diffArray)
                            );
                            setAssignedSupportCoordinators(data);
                          }}
                        />
                        {errors.support_coordinators && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                      </div>
                    )}
                    {alliedHealth && (
                      <div className='w-1/2'>
                        <div className='hidden'>
                          <select
                            {...register("allied_healther", {
                              // required: false,
                            })}
                            name='allied_healther'
                            id=''
                            className='hidden did-floating-input'
                          />
                        </div>
                        <label className='mb-1 block text-sm font-medium text-gray-700'>
                          Assigned Allied Health Workers
                        </label>
                        <SelectOption
                          isMulti={true}
                          data={
                            assignedAlliedHealther &&
                            assignedAlliedHealther.length > 0
                              ? alliedHealthers.filter((x) =>
                                  assignedAlliedHealther.find(
                                    (y) => y.value !== x.value
                                  )
                                )
                              : alliedHealthers
                          }
                          selectedOption={assignedAlliedHealther}
                          handleChange={(data) => {
                            const diffArray = getDifferenceArray(
                              assignedAlliedHealther,
                              data
                            );
                            setAssignedWorkers(
                              getDifferenceArray(assignedWorkers, diffArray)
                            );
                            setAssignedAlliedHealther(data);
                          }}
                        />
                        {errors.allied_healther && (
                          <span className='text-red-500'>
                            This field is required
                          </span>
                        )}
                      </div>
                    )}
                    </div>
                  </div>
                  {(roleAccess(
                    [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
                    PERMISSION_KEYS.PARTICIPANT,
                    PERMISSION_KEYS_CHILDREN.PARTICIPANT.SETTING.UPDATE
                  ) ||
                    roleAccess(
                      [USER_ROLE.Sp_Standard_User],
                      "participant",
                      BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.SETTING
                        .UPDATE
                    )) && (
                    <>
                      <div className='pt-6 border-t border-gray-200'></div>
                      <div className='px-4 sm:px-6 py-4 bg-gray-50 flex justify-end'>
                        <CustomButton
                          showLoading={isLoading}
                          label='Save Changes'
                          isDisabled={isLoading || isUserGracePeriodOver}
                          type='submit'
                        />
                      </div>
                    </>
                  )}

                  {roleAccess(
                    [USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager],
                    PERMISSION_KEYS.PARTICIPANT,
                    PERMISSION_KEYS_CHILDREN.PARTICIPANT.DELETE
                  ) && (
                    <>
                      <div className='py-4 border-b border-gray-300'></div>
                      <div className='pt-4 flex justify-between items-center'>
                        <div>
                          <h4 className='text-red-600 font-bold'>
                            Delete {participantLabel}
                          </h4>
                          <p className='text-sm text-gray-600'>
                            This will permanently delete the user, and all their
                            data will be removed from the system.
                          </p>
                        </div>

                        <CustomButton
                          type='button'
                          variant='danger'
                          cssClass='px-3 py-2 text-right sm:px-2 space-x-4'
                          label={`Delete ${participantLabel}`}
                          clickHandler={() => setIsShowModal(true)}
                        />
                      </div>
                      <div className='py-4 border-b border-gray-300'></div>
                    </>
                  )}

                  {isShowModal && (
                    <DeleteParticipantModal
                      isUserGracePeriodOver={isUserGracePeriodOver}
                      handleClose={() => setIsShowModal(false)} // Close modal on close
                      isShow={isShowModal} // Show the modal when isShowModal is true
                      participantId={uuid} // Uncomment and pass participant ID if needed
                    />
                  )}

                  <FamilyMemberConfirmModal
                    isOpen={Boolean(familyMemberConfirm)}
                    loading={Boolean(familyEmailBusyKey)}
                    title={
                      familyMemberConfirm?.mode === "update"
                        ? "You're about to update this family member"
                        : "You're about to remove this family member"
                    }
                    message={
                      familyMemberConfirm?.mode === "update"
                        ? `Change ${familyMemberConfirm?.oldEmail} to ${familyMemberConfirm?.newEmail}? The new address will receive an invitation, and the old one will lose access.`
                        : `Are you sure you want to remove ${familyMemberConfirm?.email}? They will lose Family App access for this participant.`
                    }
                    onClose={closeFamilyMemberConfirm}
                    onConfirm={confirmFamilyMemberAction}
                  />
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
      {showXeroImage && (
        <ImageDisplayModal
          isOpen={showXeroImage}
          setOpen={setXeroImage}
          type={PAYROLL_PLATFORMS.XERO}
          forCall='xero_contact'
          customTitle='Xero Contact ID'
        />
      )}
    </div>
  );
};

export default Settings;
